//-----Types.File-----
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}
export function deserializeProblemDetails(json: string): ProblemDetails {
  const data = JSON.parse(json) as ProblemDetails;
  initProblemDetails(data);
  return data;
}
export function initProblemDetails(_data: ProblemDetails) {
    return _data;
}
export function serializeProblemDetails(_data: ProblemDetails | undefined) {
  if (_data) {
    _data = prepareSerializeProblemDetails(_data as ProblemDetails);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeProblemDetails(_data: ProblemDetails): ProblemDetails {
  const data: Record<string, any> = { ..._data };
  return data as ProblemDetails;
}
export type HttpValidationProblemDetails = ProblemDetails  & {
  errors: { [key: string]: string[]; };
  [key: string]: any;
}
export function deserializeHttpValidationProblemDetails(json: string): HttpValidationProblemDetails {
  const data = JSON.parse(json) as HttpValidationProblemDetails;
  initHttpValidationProblemDetails(data);
  return data;
}
export function initHttpValidationProblemDetails(_data: HttpValidationProblemDetails) {
  initProblemDetails(_data);
    return _data;
}
export function serializeHttpValidationProblemDetails(_data: HttpValidationProblemDetails | undefined) {
  if (_data) {
    _data = prepareSerializeHttpValidationProblemDetails(_data as HttpValidationProblemDetails);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeHttpValidationProblemDetails(_data: HttpValidationProblemDetails): HttpValidationProblemDetails {
  const data = prepareSerializeProblemDetails(_data as HttpValidationProblemDetails) as Record<string, any>;
  return data as HttpValidationProblemDetails;
}
export type ValidationProblemDetails = HttpValidationProblemDetails  & {
  errors: { [key: string]: string[]; };
  [key: string]: any;
}
export function deserializeValidationProblemDetails(json: string): ValidationProblemDetails {
  const data = JSON.parse(json) as ValidationProblemDetails;
  initValidationProblemDetails(data);
  return data;
}
export function initValidationProblemDetails(_data: ValidationProblemDetails) {
  initHttpValidationProblemDetails(_data);
    return _data;
}
export function serializeValidationProblemDetails(_data: ValidationProblemDetails | undefined) {
  if (_data) {
    _data = prepareSerializeValidationProblemDetails(_data as ValidationProblemDetails);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeValidationProblemDetails(_data: ValidationProblemDetails): ValidationProblemDetails {
  const data = prepareSerializeHttpValidationProblemDetails(_data as ValidationProblemDetails) as Record<string, any>;
  return data as ValidationProblemDetails;
}
export type VariableDto = {
  id: number;
  name: string;
  actualUrl: string | null;
  actualValue: VariableValueDto;
  documents: VariableDocumentDto[] | null;
  documentId: number | null;
  /** Lock statuses of documents containing this variable. */
  lockStatuses: VariableLockStatusDto[];
  isEnormous: boolean;
  isTable: boolean;
  systemVariable: SystemVariableDto | null;
  parameters: { [key: string]: string; } | null;
}
export function deserializeVariableDto(json: string): VariableDto {
  const data = JSON.parse(json) as VariableDto;
  initVariableDto(data);
  return data;
}
export function initVariableDto(_data: VariableDto) {
  if (_data) {
    _data.actualValue = _data["actualValue"] && initVariableValueDto(_data["actualValue"]);
    if (Array.isArray(_data["documents"])) {
      _data.documents = _data["documents"].map(item => 
        initVariableDocumentDto(item)
      );
    }
    if (Array.isArray(_data["lockStatuses"])) {
      _data.lockStatuses = _data["lockStatuses"].map(item => 
        initVariableLockStatusDto(item)
      );
    }
    _data.systemVariable = _data["systemVariable"] && initSystemVariableDto(_data["systemVariable"]);
  }
  return _data;
}
export function serializeVariableDto(_data: VariableDto | undefined) {
  if (_data) {
    _data = prepareSerializeVariableDto(_data as VariableDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeVariableDto(_data: VariableDto): VariableDto {
  const data: Record<string, any> = { ..._data };
  data["actualValue"] = _data.actualValue && prepareSerializeVariableValueDto(_data.actualValue);
  if (Array.isArray(_data.documents)) {
    data["documents"] = _data.documents.map(item => 
        prepareSerializeVariableDocumentDto(item)
    );
  }
  if (Array.isArray(_data.lockStatuses)) {
    data["lockStatuses"] = _data.lockStatuses.map(item => 
        prepareSerializeVariableLockStatusDto(item)
    );
  }
  data["systemVariable"] = _data.systemVariable && prepareSerializeSystemVariableDto(_data.systemVariable);
  return data as VariableDto;
}
export type VariableValueDto = {
  value: string;
  alternateValue: string | null;
  variableType: VariableType;
  urlType: UrlType | null;
  /** Indicates if variable has type Auto
and data by its url has differ with its Value */
  hasUpdatedData: boolean;
  /** Date of detecting updated data at external service. */
  updatedDataDetectedDate: Date | null;
}
export function deserializeVariableValueDto(json: string): VariableValueDto {
  const data = JSON.parse(json) as VariableValueDto;
  initVariableValueDto(data);
  return data;
}
export function initVariableValueDto(_data: VariableValueDto) {
  if (_data) {
    _data.variableType = _data["variableType"];
    _data.urlType = _data["urlType"];
    _data.updatedDataDetectedDate = _data["updatedDataDetectedDate"] ? new Date(_data["updatedDataDetectedDate"].toString()) : <any>null;
  }
  return _data;
}
export function serializeVariableValueDto(_data: VariableValueDto | undefined) {
  if (_data) {
    _data = prepareSerializeVariableValueDto(_data as VariableValueDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeVariableValueDto(_data: VariableValueDto): VariableValueDto {
  const data: Record<string, any> = { ..._data };
  data["updatedDataDetectedDate"] = _data.updatedDataDetectedDate && _data.updatedDataDetectedDate.toISOString();
  return data as VariableValueDto;
}
export enum VariableType {
    Manual = "Manual",
    Auto = "Auto",
}
export enum UrlType {
    Default = "Default",
    Queries = "Queries",
    ServiceBus = "ServiceBus",
    Swagger = "Swagger",
    Dot = "Dot",
    Csproj = "Csproj",
    PackageJson = "PackageJson",
    Dgml = "Dgml",
    Tokyo = "Tokyo",
    Soup = "Soup",
    EditableDgml = "EditableDgml",
    EditableDot = "EditableDot",
}
export type VariableDocumentDto = {
  id: number;
  name: string;
  projectId: number;
  revisionId: number;
  revisionVersion: string | null;
}
export function deserializeVariableDocumentDto(json: string): VariableDocumentDto {
  const data = JSON.parse(json) as VariableDocumentDto;
  initVariableDocumentDto(data);
  return data;
}
export function initVariableDocumentDto(_data: VariableDocumentDto) {
    return _data;
}
export function serializeVariableDocumentDto(_data: VariableDocumentDto | undefined) {
  if (_data) {
    _data = prepareSerializeVariableDocumentDto(_data as VariableDocumentDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeVariableDocumentDto(_data: VariableDocumentDto): VariableDocumentDto {
  const data: Record<string, any> = { ..._data };
  return data as VariableDocumentDto;
}
/** Information about a variable that is currently locked by a user. */
export type VariableLockStatusDto = {
  /** The name of the user who has locked the variable. */
  lockedByUserName: string;
  /** The id of the document from which the variable is locked. */
  lockFromDocumentId: number;
}
export function deserializeVariableLockStatusDto(json: string): VariableLockStatusDto {
  const data = JSON.parse(json) as VariableLockStatusDto;
  initVariableLockStatusDto(data);
  return data;
}
export function initVariableLockStatusDto(_data: VariableLockStatusDto) {
    return _data;
}
export function serializeVariableLockStatusDto(_data: VariableLockStatusDto | undefined) {
  if (_data) {
    _data = prepareSerializeVariableLockStatusDto(_data as VariableLockStatusDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeVariableLockStatusDto(_data: VariableLockStatusDto): VariableLockStatusDto {
  const data: Record<string, any> = { ..._data };
  return data as VariableLockStatusDto;
}
export type SystemVariableDto = {
  /** Set for document scoped system variables only.  */
  basedOnDocumentId: number | null;
  isTracked: boolean;
  type: SystemVariableType;
  /** Set for revision scoped system variables only.  */
  revisionId: number | null;
}
export function deserializeSystemVariableDto(json: string): SystemVariableDto {
  const data = JSON.parse(json) as SystemVariableDto;
  initSystemVariableDto(data);
  return data;
}
export function initSystemVariableDto(_data: SystemVariableDto) {
  if (_data) {
    _data.type = _data["type"];
  }
  return _data;
}
export function serializeSystemVariableDto(_data: SystemVariableDto | undefined) {
  if (_data) {
    _data = prepareSerializeSystemVariableDto(_data as SystemVariableDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeSystemVariableDto(_data: SystemVariableDto): SystemVariableDto {
  const data: Record<string, any> = { ..._data };
  return data as SystemVariableDto;
}
export enum SystemVariableType {
    Version = "Version",
    Date = "Date",
    VersionHistory = "VersionHistory",
    Name = "Name",
    DescriptionOfAmendments = "DescriptionOfAmendments",
}
export type CreateVariableDto = {
  projectId: number;
  name: string;
  value: string;
  url: string;
  variableType: VariableType;
  urlType: UrlType | null;
  revisionId: number;
  parameters: { [key: string]: string; } | null;
  /** Used only for System document variables to store version and name.
Refers to initial document id. */
  basedOnDocumentId: number | null;
  /** Used only for System revision variables to store description of amendments.
Refers to the revision the variable is bound to. */
  basedOnRevisionId: number | null;
  /** Used only for local variables.
Refers to document at which level it is accessible. */
  documentId: number | null;
  /** Indicates if variable is tracked. Used for variable with table value.
Fetches updates from document, where it was inserted. */
  isTracked: boolean;
  systemVariableType: SystemVariableType | null;
}
export function deserializeCreateVariableDto(json: string): CreateVariableDto {
  const data = JSON.parse(json) as CreateVariableDto;
  initCreateVariableDto(data);
  return data;
}
export function initCreateVariableDto(_data: CreateVariableDto) {
  if (_data) {
    _data.variableType = _data["variableType"];
    _data.urlType = _data["urlType"];
    _data.systemVariableType = _data["systemVariableType"];
  }
  return _data;
}
export function serializeCreateVariableDto(_data: CreateVariableDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateVariableDto(_data as CreateVariableDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateVariableDto(_data: CreateVariableDto): CreateVariableDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateVariableDto;
}
export type PatchVariableDto = {
  name?: string;
  actualValue?: string;
  alternateValue?: string | null;
  actualUrl?: string | null;
  variableType?: VariableType;
  urlType?: UrlType | null;
  documentId?: number | null;
  parameters?: { [key: string]: string; } | null;
}
export function deserializePatchVariableDto(json: string): PatchVariableDto {
  const data = JSON.parse(json) as PatchVariableDto;
  initPatchVariableDto(data);
  return data;
}
export function initPatchVariableDto(_data: PatchVariableDto) {
  if (_data) {
    _data.variableType = _data["variableType"];
    _data.urlType = _data["urlType"];
  }
  return _data;
}
export function serializePatchVariableDto(_data: PatchVariableDto | undefined) {
  if (_data) {
    _data = prepareSerializePatchVariableDto(_data as PatchVariableDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatchVariableDto(_data: PatchVariableDto): PatchVariableDto {
  const data: Record<string, any> = { ..._data };
  return data as PatchVariableDto;
}
export type PatchVariableEntry = {
  id: number;
  revisionId: number;
  patchDto: PatchVariableDto;
}
export function deserializePatchVariableEntry(json: string): PatchVariableEntry {
  const data = JSON.parse(json) as PatchVariableEntry;
  initPatchVariableEntry(data);
  return data;
}
export function initPatchVariableEntry(_data: PatchVariableEntry) {
  if (_data) {
    _data.patchDto = _data["patchDto"] && initPatchVariableDto(_data["patchDto"]);
  }
  return _data;
}
export function serializePatchVariableEntry(_data: PatchVariableEntry | undefined) {
  if (_data) {
    _data = prepareSerializePatchVariableEntry(_data as PatchVariableEntry);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatchVariableEntry(_data: PatchVariableEntry): PatchVariableEntry {
  const data: Record<string, any> = { ..._data };
  data["patchDto"] = _data.patchDto && prepareSerializePatchVariableDto(_data.patchDto);
  return data as PatchVariableEntry;
}
export type PagedResultOfVariableListItemDto = {
  data: VariableListItemDto[];
  totalCount: number;
}
export function deserializePagedResultOfVariableListItemDto(json: string): PagedResultOfVariableListItemDto {
  const data = JSON.parse(json) as PagedResultOfVariableListItemDto;
  initPagedResultOfVariableListItemDto(data);
  return data;
}
export function initPagedResultOfVariableListItemDto(_data: PagedResultOfVariableListItemDto) {
  if (_data) {
    if (Array.isArray(_data["data"])) {
      _data.data = _data["data"].map(item => 
        initVariableListItemDto(item)
      );
    }
  }
  return _data;
}
export function serializePagedResultOfVariableListItemDto(_data: PagedResultOfVariableListItemDto | undefined) {
  if (_data) {
    _data = prepareSerializePagedResultOfVariableListItemDto(_data as PagedResultOfVariableListItemDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePagedResultOfVariableListItemDto(_data: PagedResultOfVariableListItemDto): PagedResultOfVariableListItemDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.data)) {
    data["data"] = _data.data.map(item => 
        prepareSerializeVariableListItemDto(item)
    );
  }
  return data as PagedResultOfVariableListItemDto;
}
export type VariableListItemDto = {
  id: number;
  name: string;
  actualUrl: string | null;
  actualValue: VariableValueDto;
  /** Used only for System document variables. Refers to initial document id. */
  basedOnDocument: BasedOnDocumentDto | null;
  /** Used only for revision scoped system variables to store description of amendments. */
  revisionId: number | null;
  /** Used only for local variables.
Refers to document at which level it is accessible. */
  documentId: number | null;
  /** Documents containing current variable. */
  documents: VariableDocumentDto[];
  /** Lock statuses of documents containing this variable. */
  lockStatuses: VariableLockStatusDto[];
  isTable: boolean;
  systemVariableType: SystemVariableType | null;
}
export function deserializeVariableListItemDto(json: string): VariableListItemDto {
  const data = JSON.parse(json) as VariableListItemDto;
  initVariableListItemDto(data);
  return data;
}
export function initVariableListItemDto(_data: VariableListItemDto) {
  if (_data) {
    _data.actualValue = _data["actualValue"] && initVariableValueDto(_data["actualValue"]);
    _data.basedOnDocument = _data["basedOnDocument"] && initBasedOnDocumentDto(_data["basedOnDocument"]);
    if (Array.isArray(_data["documents"])) {
      _data.documents = _data["documents"].map(item => 
        initVariableDocumentDto(item)
      );
    }
    if (Array.isArray(_data["lockStatuses"])) {
      _data.lockStatuses = _data["lockStatuses"].map(item => 
        initVariableLockStatusDto(item)
      );
    }
    _data.systemVariableType = _data["systemVariableType"];
  }
  return _data;
}
export function serializeVariableListItemDto(_data: VariableListItemDto | undefined) {
  if (_data) {
    _data = prepareSerializeVariableListItemDto(_data as VariableListItemDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeVariableListItemDto(_data: VariableListItemDto): VariableListItemDto {
  const data: Record<string, any> = { ..._data };
  data["actualValue"] = _data.actualValue && prepareSerializeVariableValueDto(_data.actualValue);
  data["basedOnDocument"] = _data.basedOnDocument && prepareSerializeBasedOnDocumentDto(_data.basedOnDocument);
  if (Array.isArray(_data.documents)) {
    data["documents"] = _data.documents.map(item => 
        prepareSerializeVariableDocumentDto(item)
    );
  }
  if (Array.isArray(_data.lockStatuses)) {
    data["lockStatuses"] = _data.lockStatuses.map(item => 
        prepareSerializeVariableLockStatusDto(item)
    );
  }
  return data as VariableListItemDto;
}
export type BasedOnDocumentDto = {
  id: number;
  name: string;
}
export function deserializeBasedOnDocumentDto(json: string): BasedOnDocumentDto {
  const data = JSON.parse(json) as BasedOnDocumentDto;
  initBasedOnDocumentDto(data);
  return data;
}
export function initBasedOnDocumentDto(_data: BasedOnDocumentDto) {
    return _data;
}
export function serializeBasedOnDocumentDto(_data: BasedOnDocumentDto | undefined) {
  if (_data) {
    _data = prepareSerializeBasedOnDocumentDto(_data as BasedOnDocumentDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeBasedOnDocumentDto(_data: BasedOnDocumentDto): BasedOnDocumentDto {
  const data: Record<string, any> = { ..._data };
  return data as BasedOnDocumentDto;
}
export enum SortOrder {
    Asc = "Asc",
    Desc = "Desc",
}
export type MergeVariablesDto = {
  targetVariableId: number;
  sourceVariableId: number;
  revisionId: number;
}
export function deserializeMergeVariablesDto(json: string): MergeVariablesDto {
  const data = JSON.parse(json) as MergeVariablesDto;
  initMergeVariablesDto(data);
  return data;
}
export function initMergeVariablesDto(_data: MergeVariablesDto) {
    return _data;
}
export function serializeMergeVariablesDto(_data: MergeVariablesDto | undefined) {
  if (_data) {
    _data = prepareSerializeMergeVariablesDto(_data as MergeVariablesDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeMergeVariablesDto(_data: MergeVariablesDto): MergeVariablesDto {
  const data: Record<string, any> = { ..._data };
  return data as MergeVariablesDto;
}
export type ReplaceUrlDto = {
  oldUrl: string;
  newUrl: string;
  urlType: UrlType | null;
}
export function deserializeReplaceUrlDto(json: string): ReplaceUrlDto {
  const data = JSON.parse(json) as ReplaceUrlDto;
  initReplaceUrlDto(data);
  return data;
}
export function initReplaceUrlDto(_data: ReplaceUrlDto) {
  if (_data) {
    _data.urlType = _data["urlType"];
  }
  return _data;
}
export function serializeReplaceUrlDto(_data: ReplaceUrlDto | undefined) {
  if (_data) {
    _data = prepareSerializeReplaceUrlDto(_data as ReplaceUrlDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeReplaceUrlDto(_data: ReplaceUrlDto): ReplaceUrlDto {
  const data: Record<string, any> = { ..._data };
  return data as ReplaceUrlDto;
}
export type CurrentUserDto = {
  id: string;
  username: string;
  firstName: string;
  lastName: string;
  permissions: string[];
  email: string;
  isSuperAdmin: boolean;
}
export function deserializeCurrentUserDto(json: string): CurrentUserDto {
  const data = JSON.parse(json) as CurrentUserDto;
  initCurrentUserDto(data);
  return data;
}
export function initCurrentUserDto(_data: CurrentUserDto) {
  if (_data) {
    _data.permissions = _data["permissions"];
  }
  return _data;
}
export function serializeCurrentUserDto(_data: CurrentUserDto | undefined) {
  if (_data) {
    _data = prepareSerializeCurrentUserDto(_data as CurrentUserDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCurrentUserDto(_data: CurrentUserDto): CurrentUserDto {
  const data: Record<string, any> = { ..._data };
  return data as CurrentUserDto;
}
export type ResetPasswordDto = {
  username: string;
  token: string;
  newPassword: string;
}
export function deserializeResetPasswordDto(json: string): ResetPasswordDto {
  const data = JSON.parse(json) as ResetPasswordDto;
  initResetPasswordDto(data);
  return data;
}
export function initResetPasswordDto(_data: ResetPasswordDto) {
    return _data;
}
export function serializeResetPasswordDto(_data: ResetPasswordDto | undefined) {
  if (_data) {
    _data = prepareSerializeResetPasswordDto(_data as ResetPasswordDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeResetPasswordDto(_data: ResetPasswordDto): ResetPasswordDto {
  const data: Record<string, any> = { ..._data };
  return data as ResetPasswordDto;
}
export type ChangePasswordDto = {
  oldPassword: string;
  newPassword: string;
}
export function deserializeChangePasswordDto(json: string): ChangePasswordDto {
  const data = JSON.parse(json) as ChangePasswordDto;
  initChangePasswordDto(data);
  return data;
}
export function initChangePasswordDto(_data: ChangePasswordDto) {
    return _data;
}
export function serializeChangePasswordDto(_data: ChangePasswordDto | undefined) {
  if (_data) {
    _data = prepareSerializeChangePasswordDto(_data as ChangePasswordDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeChangePasswordDto(_data: ChangePasswordDto): ChangePasswordDto {
  const data: Record<string, any> = { ..._data };
  return data as ChangePasswordDto;
}
export type CreateTestTenantDto = {
  userEmail: string;
  userPassword: string;
  isSuperAdmin: boolean;
}
export function deserializeCreateTestTenantDto(json: string): CreateTestTenantDto {
  const data = JSON.parse(json) as CreateTestTenantDto;
  initCreateTestTenantDto(data);
  return data;
}
export function initCreateTestTenantDto(_data: CreateTestTenantDto) {
    return _data;
}
export function serializeCreateTestTenantDto(_data: CreateTestTenantDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateTestTenantDto(_data as CreateTestTenantDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateTestTenantDto(_data: CreateTestTenantDto): CreateTestTenantDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateTestTenantDto;
}
export type TemplateDto = {
  id: number;
  initialId: number | null;
  name: string;
  content: string;
  isExported: boolean;
  isNeedToBeReopened: boolean;
  auditData: AuditDataDto | null;
}
export function deserializeTemplateDto(json: string): TemplateDto {
  const data = JSON.parse(json) as TemplateDto;
  initTemplateDto(data);
  return data;
}
export function initTemplateDto(_data: TemplateDto) {
  if (_data) {
    _data.auditData = _data["auditData"] && initAuditDataDto(_data["auditData"]);
  }
  return _data;
}
export function serializeTemplateDto(_data: TemplateDto | undefined) {
  if (_data) {
    _data = prepareSerializeTemplateDto(_data as TemplateDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeTemplateDto(_data: TemplateDto): TemplateDto {
  const data: Record<string, any> = { ..._data };
  data["auditData"] = _data.auditData && prepareSerializeAuditDataDto(_data.auditData);
  return data as TemplateDto;
}
export type AuditDataDto = {
  created: AuditEntryDto | null;
  modified: AuditEntryDto | null;
}
export function deserializeAuditDataDto(json: string): AuditDataDto {
  const data = JSON.parse(json) as AuditDataDto;
  initAuditDataDto(data);
  return data;
}
export function initAuditDataDto(_data: AuditDataDto) {
  if (_data) {
    _data.created = _data["created"] && initAuditEntryDto(_data["created"]);
    _data.modified = _data["modified"] && initAuditEntryDto(_data["modified"]);
  }
  return _data;
}
export function serializeAuditDataDto(_data: AuditDataDto | undefined) {
  if (_data) {
    _data = prepareSerializeAuditDataDto(_data as AuditDataDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeAuditDataDto(_data: AuditDataDto): AuditDataDto {
  const data: Record<string, any> = { ..._data };
  data["created"] = _data.created && prepareSerializeAuditEntryDto(_data.created);
  data["modified"] = _data.modified && prepareSerializeAuditEntryDto(_data.modified);
  return data as AuditDataDto;
}
export type AuditEntryDto = {
  date: Date;
  byId: string;
  byName: string;
}
export function deserializeAuditEntryDto(json: string): AuditEntryDto {
  const data = JSON.parse(json) as AuditEntryDto;
  initAuditEntryDto(data);
  return data;
}
export function initAuditEntryDto(_data: AuditEntryDto) {
  if (_data) {
    _data.date = _data["date"] ? new Date(_data["date"].toString()) : <any>null;
  }
  return _data;
}
export function serializeAuditEntryDto(_data: AuditEntryDto | undefined) {
  if (_data) {
    _data = prepareSerializeAuditEntryDto(_data as AuditEntryDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeAuditEntryDto(_data: AuditEntryDto): AuditEntryDto {
  const data: Record<string, any> = { ..._data };
  data["date"] = _data.date && _data.date.toISOString();
  return data as AuditEntryDto;
}
export type CreateTemplateDto = {
  name: string;
  content: string;
  /** Comment associated with the creation of the template. */
  creationComment: string | null;
  isImported: boolean;
  folderId: string | null;
  initialId: number | null;
}
export function deserializeCreateTemplateDto(json: string): CreateTemplateDto {
  const data = JSON.parse(json) as CreateTemplateDto;
  initCreateTemplateDto(data);
  return data;
}
export function initCreateTemplateDto(_data: CreateTemplateDto) {
    return _data;
}
export function serializeCreateTemplateDto(_data: CreateTemplateDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateTemplateDto(_data as CreateTemplateDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateTemplateDto(_data: CreateTemplateDto): CreateTemplateDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateTemplateDto;
}
export type UpdateTemplateDto = {
  creationComment?: string | null;
}
export function deserializeUpdateTemplateDto(json: string): UpdateTemplateDto {
  const data = JSON.parse(json) as UpdateTemplateDto;
  initUpdateTemplateDto(data);
  return data;
}
export function initUpdateTemplateDto(_data: UpdateTemplateDto) {
    return _data;
}
export function serializeUpdateTemplateDto(_data: UpdateTemplateDto | undefined) {
  if (_data) {
    _data = prepareSerializeUpdateTemplateDto(_data as UpdateTemplateDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeUpdateTemplateDto(_data: UpdateTemplateDto): UpdateTemplateDto {
  const data: Record<string, any> = { ..._data };
  return data as UpdateTemplateDto;
}
export type TemplateVersionHistoryItemDto = {
  id: number;
  name: string;
  comment: string | null;
  hasDerivedDocuments: boolean;
  auditData: AuditDataDto | null;
}
export function deserializeTemplateVersionHistoryItemDto(json: string): TemplateVersionHistoryItemDto {
  const data = JSON.parse(json) as TemplateVersionHistoryItemDto;
  initTemplateVersionHistoryItemDto(data);
  return data;
}
export function initTemplateVersionHistoryItemDto(_data: TemplateVersionHistoryItemDto) {
  if (_data) {
    _data.auditData = _data["auditData"] && initAuditDataDto(_data["auditData"]);
  }
  return _data;
}
export function serializeTemplateVersionHistoryItemDto(_data: TemplateVersionHistoryItemDto | undefined) {
  if (_data) {
    _data = prepareSerializeTemplateVersionHistoryItemDto(_data as TemplateVersionHistoryItemDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeTemplateVersionHistoryItemDto(_data: TemplateVersionHistoryItemDto): TemplateVersionHistoryItemDto {
  const data: Record<string, any> = { ..._data };
  data["auditData"] = _data.auditData && prepareSerializeAuditDataDto(_data.auditData);
  return data as TemplateVersionHistoryItemDto;
}
export type PagedResultOfTemplateListItemDto = {
  data: TemplateListItemDto[];
  totalCount: number;
}
export function deserializePagedResultOfTemplateListItemDto(json: string): PagedResultOfTemplateListItemDto {
  const data = JSON.parse(json) as PagedResultOfTemplateListItemDto;
  initPagedResultOfTemplateListItemDto(data);
  return data;
}
export function initPagedResultOfTemplateListItemDto(_data: PagedResultOfTemplateListItemDto) {
  if (_data) {
    if (Array.isArray(_data["data"])) {
      _data.data = _data["data"].map(item => 
        initTemplateListItemDto(item)
      );
    }
  }
  return _data;
}
export function serializePagedResultOfTemplateListItemDto(_data: PagedResultOfTemplateListItemDto | undefined) {
  if (_data) {
    _data = prepareSerializePagedResultOfTemplateListItemDto(_data as PagedResultOfTemplateListItemDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePagedResultOfTemplateListItemDto(_data: PagedResultOfTemplateListItemDto): PagedResultOfTemplateListItemDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.data)) {
    data["data"] = _data.data.map(item => 
        prepareSerializeTemplateListItemDto(item)
    );
  }
  return data as PagedResultOfTemplateListItemDto;
}
export type TemplateListItemDto = {
  id: number;
  initialId: number | null;
  name: string;
  isExported: boolean;
  auditData: AuditDataDto | null;
  deletionBlockReason: DocumentDeletionBlockReason;
  canBeDeleted: boolean;
}
export function deserializeTemplateListItemDto(json: string): TemplateListItemDto {
  const data = JSON.parse(json) as TemplateListItemDto;
  initTemplateListItemDto(data);
  return data;
}
export function initTemplateListItemDto(_data: TemplateListItemDto) {
  if (_data) {
    _data.auditData = _data["auditData"] && initAuditDataDto(_data["auditData"]);
    _data.deletionBlockReason = _data["deletionBlockReason"];
  }
  return _data;
}
export function serializeTemplateListItemDto(_data: TemplateListItemDto | undefined) {
  if (_data) {
    _data = prepareSerializeTemplateListItemDto(_data as TemplateListItemDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeTemplateListItemDto(_data: TemplateListItemDto): TemplateListItemDto {
  const data: Record<string, any> = { ..._data };
  data["auditData"] = _data.auditData && prepareSerializeAuditDataDto(_data.auditData);
  return data as TemplateListItemDto;
}
export enum DocumentDeletionBlockReason {
    None = "None",
    HasDerivedDocuments = "HasDerivedDocuments",
    HasActiveEditors = "HasActiveEditors",
}
export type ProjectElement = {
  id: string;
  name: string;
  type: string;
}
export function deserializeProjectElement(json: string): ProjectElement {
  const data = JSON.parse(json) as ProjectElement;
  if (data["type"] === "Folder") {
    return initProjectFolder(data as ProjectFolder);
  }
  if (data["type"] === "Document") {
    return initProjectDocument(data as ProjectDocument);
  }
  initProjectElement(data);
  return data;
}
export function initProjectElement(_data: ProjectElement) {
    return _data;
}
export function serializeProjectElement(_data: ProjectElement | undefined) {
  if (_data) {
    _data = prepareSerializeProjectElement(_data as ProjectElement);
      _data["type"] = "ProjectElement";
  }
  return JSON.stringify(_data);
}
export function prepareSerializeProjectElement(_data: ProjectElement): ProjectElement {
  const data: Record<string, any> = { ..._data };
  return data as ProjectElement;
}
export type ProjectFolder = ProjectElement  & {
  children: ProjectElement[];
  collapsed: boolean;
}
export function deserializeProjectFolder(json: string): ProjectFolder {
  const data = JSON.parse(json) as ProjectFolder;
  initProjectFolder(data);
  return data;
}
export function initProjectFolder(_data: ProjectFolder) {
  initProjectElement(_data);
  if (_data) {
    if (Array.isArray(_data["children"])) {
      _data.children = _data["children"].map(item => 
        initProjectElement(item)
      );
    }
  }
  return _data;
}
export function serializeProjectFolder(_data: ProjectFolder | undefined) {
  if (_data) {
    _data = prepareSerializeProjectFolder(_data as ProjectFolder);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeProjectFolder(_data: ProjectFolder): ProjectFolder {
  const data = prepareSerializeProjectElement(_data as ProjectFolder) as Record<string, any>;
  if (Array.isArray(_data.children)) {
    data["children"] = _data.children.map(item => 
        prepareSerializeProjectElement(item)
    );
  }
  return data as ProjectFolder;
}
export type ProjectDocument = ProjectElement  & {
  documentId: number;
}
export function deserializeProjectDocument(json: string): ProjectDocument {
  const data = JSON.parse(json) as ProjectDocument;
  initProjectDocument(data);
  return data;
}
export function initProjectDocument(_data: ProjectDocument) {
  initProjectElement(_data);
    return _data;
}
export function serializeProjectDocument(_data: ProjectDocument | undefined) {
  if (_data) {
    _data = prepareSerializeProjectDocument(_data as ProjectDocument);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeProjectDocument(_data: ProjectDocument): ProjectDocument {
  const data = prepareSerializeProjectElement(_data as ProjectDocument) as Record<string, any>;
  return data as ProjectDocument;
}
export type PatchFoldersDto = {
  folders?: ProjectElement[];
}
export function deserializePatchFoldersDto(json: string): PatchFoldersDto {
  const data = JSON.parse(json) as PatchFoldersDto;
  initPatchFoldersDto(data);
  return data;
}
export function initPatchFoldersDto(_data: PatchFoldersDto) {
  if (_data) {
    if (Array.isArray(_data["folders"])) {
      _data.folders = _data["folders"].map(item => 
        initProjectElement(item)
      );
    }
  }
  return _data;
}
export function serializePatchFoldersDto(_data: PatchFoldersDto | undefined) {
  if (_data) {
    _data = prepareSerializePatchFoldersDto(_data as PatchFoldersDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatchFoldersDto(_data: PatchFoldersDto): PatchFoldersDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.folders)) {
    data["folders"] = _data.folders.map(item => 
        prepareSerializeProjectElement(item)
    );
  }
  return data as PatchFoldersDto;
}
export type SignerDto = {
  id: number;
  canBeModified: boolean;
  firstName: string;
  lastName: string;
  email: string;
}
export function deserializeSignerDto(json: string): SignerDto {
  const data = JSON.parse(json) as SignerDto;
  initSignerDto(data);
  return data;
}
export function initSignerDto(_data: SignerDto) {
    return _data;
}
export function serializeSignerDto(_data: SignerDto | undefined) {
  if (_data) {
    _data = prepareSerializeSignerDto(_data as SignerDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeSignerDto(_data: SignerDto): SignerDto {
  const data: Record<string, any> = { ..._data };
  return data as SignerDto;
}
export type SignerCreateDto = {
  firstName: string;
  lastName: string;
  email: string;
}
export function deserializeSignerCreateDto(json: string): SignerCreateDto {
  const data = JSON.parse(json) as SignerCreateDto;
  initSignerCreateDto(data);
  return data;
}
export function initSignerCreateDto(_data: SignerCreateDto) {
    return _data;
}
export function serializeSignerCreateDto(_data: SignerCreateDto | undefined) {
  if (_data) {
    _data = prepareSerializeSignerCreateDto(_data as SignerCreateDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeSignerCreateDto(_data: SignerCreateDto): SignerCreateDto {
  const data: Record<string, any> = { ..._data };
  return data as SignerCreateDto;
}
export type PatchSignerDto = {
  firstName?: string;
  lastName?: string;
  email?: string;
}
export function deserializePatchSignerDto(json: string): PatchSignerDto {
  const data = JSON.parse(json) as PatchSignerDto;
  initPatchSignerDto(data);
  return data;
}
export function initPatchSignerDto(_data: PatchSignerDto) {
    return _data;
}
export function serializePatchSignerDto(_data: PatchSignerDto | undefined) {
  if (_data) {
    _data = prepareSerializePatchSignerDto(_data as PatchSignerDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatchSignerDto(_data: PatchSignerDto): PatchSignerDto {
  const data: Record<string, any> = { ..._data };
  return data as PatchSignerDto;
}
export type PagedResultOfSignerDto = {
  data: SignerDto[];
  totalCount: number;
}
export function deserializePagedResultOfSignerDto(json: string): PagedResultOfSignerDto {
  const data = JSON.parse(json) as PagedResultOfSignerDto;
  initPagedResultOfSignerDto(data);
  return data;
}
export function initPagedResultOfSignerDto(_data: PagedResultOfSignerDto) {
  if (_data) {
    if (Array.isArray(_data["data"])) {
      _data.data = _data["data"].map(item => 
        initSignerDto(item)
      );
    }
  }
  return _data;
}
export function serializePagedResultOfSignerDto(_data: PagedResultOfSignerDto | undefined) {
  if (_data) {
    _data = prepareSerializePagedResultOfSignerDto(_data as PagedResultOfSignerDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePagedResultOfSignerDto(_data: PagedResultOfSignerDto): PagedResultOfSignerDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.data)) {
    data["data"] = _data.data.map(item => 
        prepareSerializeSignerDto(item)
    );
  }
  return data as PagedResultOfSignerDto;
}
/** Data of response json with multiple objects. */
export type ResponseDataOfNotificationData = {
  value: NotificationData[];
}
export function deserializeResponseDataOfNotificationData(json: string): ResponseDataOfNotificationData {
  const data = JSON.parse(json) as ResponseDataOfNotificationData;
  initResponseDataOfNotificationData(data);
  return data;
}
export function initResponseDataOfNotificationData(_data: ResponseDataOfNotificationData) {
  if (_data) {
    if (Array.isArray(_data["value"])) {
      _data.value = _data["value"].map(item => 
        initNotificationData(item)
      );
    }
  }
  return _data;
}
export function serializeResponseDataOfNotificationData(_data: ResponseDataOfNotificationData | undefined) {
  if (_data) {
    _data = prepareSerializeResponseDataOfNotificationData(_data as ResponseDataOfNotificationData);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeResponseDataOfNotificationData(_data: ResponseDataOfNotificationData): ResponseDataOfNotificationData {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.value)) {
    data["value"] = _data.value.map(item => 
        prepareSerializeNotificationData(item)
    );
  }
  return data as ResponseDataOfNotificationData;
}
/** Web hook notification data: this message is received when SharePoint "fires" a web hook. */
export type NotificationData = {
  subscriptionId: string;
  clientState: string;
  expirationDateTime: Date;
  resource: string;
  tenantId: string;
  siteUrl: string;
  webId: string;
}
export function deserializeNotificationData(json: string): NotificationData {
  const data = JSON.parse(json) as NotificationData;
  initNotificationData(data);
  return data;
}
export function initNotificationData(_data: NotificationData) {
  if (_data) {
    _data.expirationDateTime = _data["expirationDateTime"] ? new Date(_data["expirationDateTime"].toString()) : <any>null;
  }
  return _data;
}
export function serializeNotificationData(_data: NotificationData | undefined) {
  if (_data) {
    _data = prepareSerializeNotificationData(_data as NotificationData);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeNotificationData(_data: NotificationData): NotificationData {
  const data: Record<string, any> = { ..._data };
  data["expirationDateTime"] = _data.expirationDateTime && _data.expirationDateTime.toISOString();
  return data as NotificationData;
}
/** Actual applcation settings. */
export type SettingsDto = {
  /** Provides actual SharePoint url for documents exporting. */
  sharePointUrl: string;
}
export function deserializeSettingsDto(json: string): SettingsDto {
  const data = JSON.parse(json) as SettingsDto;
  initSettingsDto(data);
  return data;
}
export function initSettingsDto(_data: SettingsDto) {
    return _data;
}
export function serializeSettingsDto(_data: SettingsDto | undefined) {
  if (_data) {
    _data = prepareSerializeSettingsDto(_data as SettingsDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeSettingsDto(_data: SettingsDto): SettingsDto {
  const data: Record<string, any> = { ..._data };
  return data as SettingsDto;
}
export type RevisionDto = {
  id: number;
  version: string;
  folders: ProjectElement[];
  projectId: number;
  isCurrent: boolean;
  isExported: boolean;
  isSigning: boolean;
  sharePointImportStatus: ImportStatus;
  sharePointExportStatus: ExportStatus;
  release: string | null;
  basedOnRevisionId: number | null;
  descriptionSource: RevisionDescriptionSource;
  description: string;
}
export function deserializeRevisionDto(json: string): RevisionDto {
  const data = JSON.parse(json) as RevisionDto;
  initRevisionDto(data);
  return data;
}
export function initRevisionDto(_data: RevisionDto) {
  if (_data) {
    if (Array.isArray(_data["folders"])) {
      _data.folders = _data["folders"].map(item => 
        initProjectElement(item)
      );
    }
    _data.sharePointImportStatus = _data["sharePointImportStatus"];
    _data.sharePointExportStatus = _data["sharePointExportStatus"];
    _data.descriptionSource = _data["descriptionSource"];
  }
  return _data;
}
export function serializeRevisionDto(_data: RevisionDto | undefined) {
  if (_data) {
    _data = prepareSerializeRevisionDto(_data as RevisionDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeRevisionDto(_data: RevisionDto): RevisionDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.folders)) {
    data["folders"] = _data.folders.map(item => 
        prepareSerializeProjectElement(item)
    );
  }
  return data as RevisionDto;
}
export enum ImportStatus {
    NotStarted = "NotStarted",
    InProgress = "InProgress",
    Imported = "Imported",
}
export enum ExportStatus {
    NotStarted = "NotStarted",
    InProgress = "InProgress",
}
export enum RevisionDescriptionSource {
    Revision = "Revision",
    Release = "Release",
}
export type CreateRevisionDto = {
  version: string;
  projectId: number;
  /** Release this revision belongs to. */
  release: string | null;
  basedOnRevisionId: number | null;
  descriptionSource: RevisionDescriptionSource;
}
export function deserializeCreateRevisionDto(json: string): CreateRevisionDto {
  const data = JSON.parse(json) as CreateRevisionDto;
  initCreateRevisionDto(data);
  return data;
}
export function initCreateRevisionDto(_data: CreateRevisionDto) {
  if (_data) {
    _data.descriptionSource = _data["descriptionSource"];
  }
  return _data;
}
export function serializeCreateRevisionDto(_data: CreateRevisionDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateRevisionDto(_data as CreateRevisionDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateRevisionDto(_data: CreateRevisionDto): CreateRevisionDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateRevisionDto;
}
export type PatchRevisionDto = {
  version?: string;
  folders?: ProjectElement[];
  /** Release this revision belongs to. */
  release?: string | null;
  descriptionSource?: RevisionDescriptionSource;
}
export function deserializePatchRevisionDto(json: string): PatchRevisionDto {
  const data = JSON.parse(json) as PatchRevisionDto;
  initPatchRevisionDto(data);
  return data;
}
export function initPatchRevisionDto(_data: PatchRevisionDto) {
  if (_data) {
    if (Array.isArray(_data["folders"])) {
      _data.folders = _data["folders"].map(item => 
        initProjectElement(item)
      );
    }
    _data.descriptionSource = _data["descriptionSource"];
  }
  return _data;
}
export function serializePatchRevisionDto(_data: PatchRevisionDto | undefined) {
  if (_data) {
    _data = prepareSerializePatchRevisionDto(_data as PatchRevisionDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatchRevisionDto(_data: PatchRevisionDto): PatchRevisionDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.folders)) {
    data["folders"] = _data.folders.map(item => 
        prepareSerializeProjectElement(item)
    );
  }
  return data as PatchRevisionDto;
}
export type PagedResultOfRevisionListItemDto = {
  data: RevisionListItemDto[];
  totalCount: number;
}
export function deserializePagedResultOfRevisionListItemDto(json: string): PagedResultOfRevisionListItemDto {
  const data = JSON.parse(json) as PagedResultOfRevisionListItemDto;
  initPagedResultOfRevisionListItemDto(data);
  return data;
}
export function initPagedResultOfRevisionListItemDto(_data: PagedResultOfRevisionListItemDto) {
  if (_data) {
    if (Array.isArray(_data["data"])) {
      _data.data = _data["data"].map(item => 
        initRevisionListItemDto(item)
      );
    }
  }
  return _data;
}
export function serializePagedResultOfRevisionListItemDto(_data: PagedResultOfRevisionListItemDto | undefined) {
  if (_data) {
    _data = prepareSerializePagedResultOfRevisionListItemDto(_data as PagedResultOfRevisionListItemDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePagedResultOfRevisionListItemDto(_data: PagedResultOfRevisionListItemDto): PagedResultOfRevisionListItemDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.data)) {
    data["data"] = _data.data.map(item => 
        prepareSerializeRevisionListItemDto(item)
    );
  }
  return data as PagedResultOfRevisionListItemDto;
}
export type RevisionListItemDto = {
  id: number;
  version: string;
  folders: ProjectElement[];
  release: string | null;
  basedOnRevisionId: number | null;
  descriptionSource: RevisionDescriptionSource;
  description: string;
}
export function deserializeRevisionListItemDto(json: string): RevisionListItemDto {
  const data = JSON.parse(json) as RevisionListItemDto;
  initRevisionListItemDto(data);
  return data;
}
export function initRevisionListItemDto(_data: RevisionListItemDto) {
  if (_data) {
    if (Array.isArray(_data["folders"])) {
      _data.folders = _data["folders"].map(item => 
        initProjectElement(item)
      );
    }
    _data.descriptionSource = _data["descriptionSource"];
  }
  return _data;
}
export function serializeRevisionListItemDto(_data: RevisionListItemDto | undefined) {
  if (_data) {
    _data = prepareSerializeRevisionListItemDto(_data as RevisionListItemDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeRevisionListItemDto(_data: RevisionListItemDto): RevisionListItemDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.folders)) {
    data["folders"] = _data.folders.map(item => 
        prepareSerializeProjectElement(item)
    );
  }
  return data as RevisionListItemDto;
}
export type SelectionEntryDto = {
  fullPath: string;
  selectionType: SelectionType;
  documentId: number | null;
  initialDocumentId: number | null;
}
export function deserializeSelectionEntryDto(json: string): SelectionEntryDto {
  const data = JSON.parse(json) as SelectionEntryDto;
  initSelectionEntryDto(data);
  return data;
}
export function initSelectionEntryDto(_data: SelectionEntryDto) {
  if (_data) {
    _data.selectionType = _data["selectionType"];
  }
  return _data;
}
export function serializeSelectionEntryDto(_data: SelectionEntryDto | undefined) {
  if (_data) {
    _data = prepareSerializeSelectionEntryDto(_data as SelectionEntryDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeSelectionEntryDto(_data: SelectionEntryDto): SelectionEntryDto {
  const data: Record<string, any> = { ..._data };
  return data as SelectionEntryDto;
}
export enum SelectionType {
    File = "File",
    Folder = "Folder",
}
export type SearchTeamMemberResultDto = {
  id: string;
  email: string;
  fullName: string;
}
export function deserializeSearchTeamMemberResultDto(json: string): SearchTeamMemberResultDto {
  const data = JSON.parse(json) as SearchTeamMemberResultDto;
  initSearchTeamMemberResultDto(data);
  return data;
}
export function initSearchTeamMemberResultDto(_data: SearchTeamMemberResultDto) {
    return _data;
}
export function serializeSearchTeamMemberResultDto(_data: SearchTeamMemberResultDto | undefined) {
  if (_data) {
    _data = prepareSerializeSearchTeamMemberResultDto(_data as SearchTeamMemberResultDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeSearchTeamMemberResultDto(_data: SearchTeamMemberResultDto): SearchTeamMemberResultDto {
  const data: Record<string, any> = { ..._data };
  return data as SearchTeamMemberResultDto;
}
export type ProjectDto = {
  id: number;
  name: string;
  description: string;
  iconCode: string;
  isExported: boolean;
  teamMembers: TeamMemberDto[];
  isPrivate: boolean;
  currentUserPermissions: { [key in keyof typeof ProjectResourceType]?: OperationType[]; } | null;
  settings: ProjectSettingsDto;
}
export function deserializeProjectDto(json: string): ProjectDto {
  const data = JSON.parse(json) as ProjectDto;
  initProjectDto(data);
  return data;
}
export function initProjectDto(_data: ProjectDto) {
  if (_data) {
    if (Array.isArray(_data["teamMembers"])) {
      _data.teamMembers = _data["teamMembers"].map(item => 
        initTeamMemberDto(item)
      );
    }
    _data.settings = _data["settings"] && initProjectSettingsDto(_data["settings"]);
  }
  return _data;
}
export function serializeProjectDto(_data: ProjectDto | undefined) {
  if (_data) {
    _data = prepareSerializeProjectDto(_data as ProjectDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeProjectDto(_data: ProjectDto): ProjectDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.teamMembers)) {
    data["teamMembers"] = _data.teamMembers.map(item => 
        prepareSerializeTeamMemberDto(item)
    );
  }
  data["settings"] = _data.settings && prepareSerializeProjectSettingsDto(_data.settings);
  return data as ProjectDto;
}
export type TeamMemberDto = {
  id: string;
  email: string;
  fullName: string;
  role: ProjectTeamMemberRole;
}
export function deserializeTeamMemberDto(json: string): TeamMemberDto {
  const data = JSON.parse(json) as TeamMemberDto;
  initTeamMemberDto(data);
  return data;
}
export function initTeamMemberDto(_data: TeamMemberDto) {
  if (_data) {
    _data.role = _data["role"];
  }
  return _data;
}
export function serializeTeamMemberDto(_data: TeamMemberDto | undefined) {
  if (_data) {
    _data = prepareSerializeTeamMemberDto(_data as TeamMemberDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeTeamMemberDto(_data: TeamMemberDto): TeamMemberDto {
  const data: Record<string, any> = { ..._data };
  return data as TeamMemberDto;
}
export enum ProjectTeamMemberRole {
    Viewer = "Viewer",
    Editor = "Editor",
    Responsible = "Responsible",
}
export enum ProjectResourceType {
    Project = "Project",
    Revision = "Revision",
    Document = "Document",
    Variable = "Variable",
    ProjectRole = "ProjectRole",
    Comment = "Comment",
}
export enum OperationType {
    Create = "Create",
    Read = "Read",
    Update = "Update",
    Delete = "Delete",
}
export type ProjectSettingsDto = {
  context: string;
}
export function deserializeProjectSettingsDto(json: string): ProjectSettingsDto {
  const data = JSON.parse(json) as ProjectSettingsDto;
  initProjectSettingsDto(data);
  return data;
}
export function initProjectSettingsDto(_data: ProjectSettingsDto) {
    return _data;
}
export function serializeProjectSettingsDto(_data: ProjectSettingsDto | undefined) {
  if (_data) {
    _data = prepareSerializeProjectSettingsDto(_data as ProjectSettingsDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeProjectSettingsDto(_data: ProjectSettingsDto): ProjectSettingsDto {
  const data: Record<string, any> = { ..._data };
  return data as ProjectSettingsDto;
}
export type CreateProjectDto = {
  name: string;
  description: string | null;
  iconCode: string;
  isPrivate: boolean;
  teamMembers: AddTeamMemberDto[];
  settings: CreateProjectSettingsDto;
}
export function deserializeCreateProjectDto(json: string): CreateProjectDto {
  const data = JSON.parse(json) as CreateProjectDto;
  initCreateProjectDto(data);
  return data;
}
export function initCreateProjectDto(_data: CreateProjectDto) {
  if (_data) {
    if (Array.isArray(_data["teamMembers"])) {
      _data.teamMembers = _data["teamMembers"].map(item => 
        initAddTeamMemberDto(item)
      );
    }
    _data.settings = _data["settings"] && initCreateProjectSettingsDto(_data["settings"]);
  }
  return _data;
}
export function serializeCreateProjectDto(_data: CreateProjectDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateProjectDto(_data as CreateProjectDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateProjectDto(_data: CreateProjectDto): CreateProjectDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.teamMembers)) {
    data["teamMembers"] = _data.teamMembers.map(item => 
        prepareSerializeAddTeamMemberDto(item)
    );
  }
  data["settings"] = _data.settings && prepareSerializeCreateProjectSettingsDto(_data.settings);
  return data as CreateProjectDto;
}
export type AddTeamMemberDto = {
  id: string;
  role: ProjectTeamMemberRole;
}
export function deserializeAddTeamMemberDto(json: string): AddTeamMemberDto {
  const data = JSON.parse(json) as AddTeamMemberDto;
  initAddTeamMemberDto(data);
  return data;
}
export function initAddTeamMemberDto(_data: AddTeamMemberDto) {
  if (_data) {
    _data.role = _data["role"];
  }
  return _data;
}
export function serializeAddTeamMemberDto(_data: AddTeamMemberDto | undefined) {
  if (_data) {
    _data = prepareSerializeAddTeamMemberDto(_data as AddTeamMemberDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeAddTeamMemberDto(_data: AddTeamMemberDto): AddTeamMemberDto {
  const data: Record<string, any> = { ..._data };
  return data as AddTeamMemberDto;
}
export type CreateProjectSettingsDto = {
  context: string;
}
export function deserializeCreateProjectSettingsDto(json: string): CreateProjectSettingsDto {
  const data = JSON.parse(json) as CreateProjectSettingsDto;
  initCreateProjectSettingsDto(data);
  return data;
}
export function initCreateProjectSettingsDto(_data: CreateProjectSettingsDto) {
    return _data;
}
export function serializeCreateProjectSettingsDto(_data: CreateProjectSettingsDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateProjectSettingsDto(_data as CreateProjectSettingsDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateProjectSettingsDto(_data: CreateProjectSettingsDto): CreateProjectSettingsDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateProjectSettingsDto;
}
export type PatchProjectDto = {
  name?: string;
  description?: string | null;
  iconCode?: string;
  isPrivate?: boolean;
  teamMembers?: AddTeamMemberDto[];
  settings?: PatchProjectSettingsDto;
}
export function deserializePatchProjectDto(json: string): PatchProjectDto {
  const data = JSON.parse(json) as PatchProjectDto;
  initPatchProjectDto(data);
  return data;
}
export function initPatchProjectDto(_data: PatchProjectDto) {
  if (_data) {
    if (Array.isArray(_data["teamMembers"])) {
      _data.teamMembers = _data["teamMembers"].map(item => 
        initAddTeamMemberDto(item)
      );
    }
    _data.settings = _data["settings"] && initPatchProjectSettingsDto(_data["settings"]);
  }
  return _data;
}
export function serializePatchProjectDto(_data: PatchProjectDto | undefined) {
  if (_data) {
    _data = prepareSerializePatchProjectDto(_data as PatchProjectDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatchProjectDto(_data: PatchProjectDto): PatchProjectDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.teamMembers)) {
    data["teamMembers"] = _data.teamMembers.map(item => 
        prepareSerializeAddTeamMemberDto(item)
    );
  }
  data["settings"] = _data.settings && prepareSerializePatchProjectSettingsDto(_data.settings);
  return data as PatchProjectDto;
}
export type PatchProjectSettingsDto = {
  context?: string;
}
export function deserializePatchProjectSettingsDto(json: string): PatchProjectSettingsDto {
  const data = JSON.parse(json) as PatchProjectSettingsDto;
  initPatchProjectSettingsDto(data);
  return data;
}
export function initPatchProjectSettingsDto(_data: PatchProjectSettingsDto) {
    return _data;
}
export function serializePatchProjectSettingsDto(_data: PatchProjectSettingsDto | undefined) {
  if (_data) {
    _data = prepareSerializePatchProjectSettingsDto(_data as PatchProjectSettingsDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatchProjectSettingsDto(_data: PatchProjectSettingsDto): PatchProjectSettingsDto {
  const data: Record<string, any> = { ..._data };
  return data as PatchProjectSettingsDto;
}
export type PagedResultOfProjectListItemDto = {
  data: ProjectListItemDto[];
  totalCount: number;
}
export function deserializePagedResultOfProjectListItemDto(json: string): PagedResultOfProjectListItemDto {
  const data = JSON.parse(json) as PagedResultOfProjectListItemDto;
  initPagedResultOfProjectListItemDto(data);
  return data;
}
export function initPagedResultOfProjectListItemDto(_data: PagedResultOfProjectListItemDto) {
  if (_data) {
    if (Array.isArray(_data["data"])) {
      _data.data = _data["data"].map(item => 
        initProjectListItemDto(item)
      );
    }
  }
  return _data;
}
export function serializePagedResultOfProjectListItemDto(_data: PagedResultOfProjectListItemDto | undefined) {
  if (_data) {
    _data = prepareSerializePagedResultOfProjectListItemDto(_data as PagedResultOfProjectListItemDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePagedResultOfProjectListItemDto(_data: PagedResultOfProjectListItemDto): PagedResultOfProjectListItemDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.data)) {
    data["data"] = _data.data.map(item => 
        prepareSerializeProjectListItemDto(item)
    );
  }
  return data as PagedResultOfProjectListItemDto;
}
export type ProjectListItemDto = {
  id: number;
  name: string;
  currentRevision: string;
  iconCode: string;
  teamMembers: TeamMemberDto[];
  isPrivate: boolean;
  currentUserPermissions: { [key in keyof typeof ProjectResourceType]?: OperationType[]; } | null;
}
export function deserializeProjectListItemDto(json: string): ProjectListItemDto {
  const data = JSON.parse(json) as ProjectListItemDto;
  initProjectListItemDto(data);
  return data;
}
export function initProjectListItemDto(_data: ProjectListItemDto) {
  if (_data) {
    if (Array.isArray(_data["teamMembers"])) {
      _data.teamMembers = _data["teamMembers"].map(item => 
        initTeamMemberDto(item)
      );
    }
  }
  return _data;
}
export function serializeProjectListItemDto(_data: ProjectListItemDto | undefined) {
  if (_data) {
    _data = prepareSerializeProjectListItemDto(_data as ProjectListItemDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeProjectListItemDto(_data: ProjectListItemDto): ProjectListItemDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.teamMembers)) {
    data["teamMembers"] = _data.teamMembers.map(item => 
        prepareSerializeTeamMemberDto(item)
    );
  }
  return data as ProjectListItemDto;
}
export type ProjectSignerDto = {
  id: number;
  roleId: number;
  priority: number;
  signer: SignerDto;
}
export function deserializeProjectSignerDto(json: string): ProjectSignerDto {
  const data = JSON.parse(json) as ProjectSignerDto;
  initProjectSignerDto(data);
  return data;
}
export function initProjectSignerDto(_data: ProjectSignerDto) {
  if (_data) {
    _data.signer = _data["signer"] && initSignerDto(_data["signer"]);
  }
  return _data;
}
export function serializeProjectSignerDto(_data: ProjectSignerDto | undefined) {
  if (_data) {
    _data = prepareSerializeProjectSignerDto(_data as ProjectSignerDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeProjectSignerDto(_data: ProjectSignerDto): ProjectSignerDto {
  const data: Record<string, any> = { ..._data };
  data["signer"] = _data.signer && prepareSerializeSignerDto(_data.signer);
  return data as ProjectSignerDto;
}
export type ProjectSignerCreateDto = {
  signerId: number;
  projectRoleId: number;
}
export function deserializeProjectSignerCreateDto(json: string): ProjectSignerCreateDto {
  const data = JSON.parse(json) as ProjectSignerCreateDto;
  initProjectSignerCreateDto(data);
  return data;
}
export function initProjectSignerCreateDto(_data: ProjectSignerCreateDto) {
    return _data;
}
export function serializeProjectSignerCreateDto(_data: ProjectSignerCreateDto | undefined) {
  if (_data) {
    _data = prepareSerializeProjectSignerCreateDto(_data as ProjectSignerCreateDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeProjectSignerCreateDto(_data: ProjectSignerCreateDto): ProjectSignerCreateDto {
  const data: Record<string, any> = { ..._data };
  return data as ProjectSignerCreateDto;
}
export type PagedResultOfProjectSignerDto = {
  data: ProjectSignerDto[];
  totalCount: number;
}
export function deserializePagedResultOfProjectSignerDto(json: string): PagedResultOfProjectSignerDto {
  const data = JSON.parse(json) as PagedResultOfProjectSignerDto;
  initPagedResultOfProjectSignerDto(data);
  return data;
}
export function initPagedResultOfProjectSignerDto(_data: PagedResultOfProjectSignerDto) {
  if (_data) {
    if (Array.isArray(_data["data"])) {
      _data.data = _data["data"].map(item => 
        initProjectSignerDto(item)
      );
    }
  }
  return _data;
}
export function serializePagedResultOfProjectSignerDto(_data: PagedResultOfProjectSignerDto | undefined) {
  if (_data) {
    _data = prepareSerializePagedResultOfProjectSignerDto(_data as PagedResultOfProjectSignerDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePagedResultOfProjectSignerDto(_data: PagedResultOfProjectSignerDto): PagedResultOfProjectSignerDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.data)) {
    data["data"] = _data.data.map(item => 
        prepareSerializeProjectSignerDto(item)
    );
  }
  return data as PagedResultOfProjectSignerDto;
}
export type UpdateProjectSignersDto = {
  projectRoleId: number;
  signerIds: number[];
}
export function deserializeUpdateProjectSignersDto(json: string): UpdateProjectSignersDto {
  const data = JSON.parse(json) as UpdateProjectSignersDto;
  initUpdateProjectSignersDto(data);
  return data;
}
export function initUpdateProjectSignersDto(_data: UpdateProjectSignersDto) {
  if (_data) {
    _data.signerIds = _data["signerIds"];
  }
  return _data;
}
export function serializeUpdateProjectSignersDto(_data: UpdateProjectSignersDto | undefined) {
  if (_data) {
    _data = prepareSerializeUpdateProjectSignersDto(_data as UpdateProjectSignersDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeUpdateProjectSignersDto(_data: UpdateProjectSignersDto): UpdateProjectSignersDto {
  const data: Record<string, any> = { ..._data };
  return data as UpdateProjectSignersDto;
}
export type ProjectRoleDto = {
  id: number;
  projectId: number;
  name: string;
  signers: ProjectSignerDto[] | null;
}
export function deserializeProjectRoleDto(json: string): ProjectRoleDto {
  const data = JSON.parse(json) as ProjectRoleDto;
  initProjectRoleDto(data);
  return data;
}
export function initProjectRoleDto(_data: ProjectRoleDto) {
  if (_data) {
    if (Array.isArray(_data["signers"])) {
      _data.signers = _data["signers"].map(item => 
        initProjectSignerDto(item)
      );
    }
  }
  return _data;
}
export function serializeProjectRoleDto(_data: ProjectRoleDto | undefined) {
  if (_data) {
    _data = prepareSerializeProjectRoleDto(_data as ProjectRoleDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeProjectRoleDto(_data: ProjectRoleDto): ProjectRoleDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.signers)) {
    data["signers"] = _data.signers.map(item => 
        prepareSerializeProjectSignerDto(item)
    );
  }
  return data as ProjectRoleDto;
}
export type CreateProjectRoleDto = {
  projectId: number;
  name: string;
}
export function deserializeCreateProjectRoleDto(json: string): CreateProjectRoleDto {
  const data = JSON.parse(json) as CreateProjectRoleDto;
  initCreateProjectRoleDto(data);
  return data;
}
export function initCreateProjectRoleDto(_data: CreateProjectRoleDto) {
    return _data;
}
export function serializeCreateProjectRoleDto(_data: CreateProjectRoleDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateProjectRoleDto(_data as CreateProjectRoleDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateProjectRoleDto(_data: CreateProjectRoleDto): CreateProjectRoleDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateProjectRoleDto;
}
export type PatchProjectRoleDto = {
  name?: string;
}
export function deserializePatchProjectRoleDto(json: string): PatchProjectRoleDto {
  const data = JSON.parse(json) as PatchProjectRoleDto;
  initPatchProjectRoleDto(data);
  return data;
}
export function initPatchProjectRoleDto(_data: PatchProjectRoleDto) {
    return _data;
}
export function serializePatchProjectRoleDto(_data: PatchProjectRoleDto | undefined) {
  if (_data) {
    _data = prepareSerializePatchProjectRoleDto(_data as PatchProjectRoleDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatchProjectRoleDto(_data: PatchProjectRoleDto): PatchProjectRoleDto {
  const data: Record<string, any> = { ..._data };
  return data as PatchProjectRoleDto;
}
export type PagedResultOfProjectRoleDto = {
  data: ProjectRoleDto[];
  totalCount: number;
}
export function deserializePagedResultOfProjectRoleDto(json: string): PagedResultOfProjectRoleDto {
  const data = JSON.parse(json) as PagedResultOfProjectRoleDto;
  initPagedResultOfProjectRoleDto(data);
  return data;
}
export function initPagedResultOfProjectRoleDto(_data: PagedResultOfProjectRoleDto) {
  if (_data) {
    if (Array.isArray(_data["data"])) {
      _data.data = _data["data"].map(item => 
        initProjectRoleDto(item)
      );
    }
  }
  return _data;
}
export function serializePagedResultOfProjectRoleDto(_data: PagedResultOfProjectRoleDto | undefined) {
  if (_data) {
    _data = prepareSerializePagedResultOfProjectRoleDto(_data as PagedResultOfProjectRoleDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePagedResultOfProjectRoleDto(_data: PagedResultOfProjectRoleDto): PagedResultOfProjectRoleDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.data)) {
    data["data"] = _data.data.map(item => 
        prepareSerializeProjectRoleDto(item)
    );
  }
  return data as PagedResultOfProjectRoleDto;
}
export type RephraseDto = {
  input: string;
  projectId: number;
}
export function deserializeRephraseDto(json: string): RephraseDto {
  const data = JSON.parse(json) as RephraseDto;
  initRephraseDto(data);
  return data;
}
export function initRephraseDto(_data: RephraseDto) {
    return _data;
}
export function serializeRephraseDto(_data: RephraseDto | undefined) {
  if (_data) {
    _data = prepareSerializeRephraseDto(_data as RephraseDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeRephraseDto(_data: RephraseDto): RephraseDto {
  const data: Record<string, any> = { ..._data };
  return data as RephraseDto;
}
export type PostChatMessageResult = {
  response: string;
  responseId: string;
}
export function deserializePostChatMessageResult(json: string): PostChatMessageResult {
  const data = JSON.parse(json) as PostChatMessageResult;
  initPostChatMessageResult(data);
  return data;
}
export function initPostChatMessageResult(_data: PostChatMessageResult) {
    return _data;
}
export function serializePostChatMessageResult(_data: PostChatMessageResult | undefined) {
  if (_data) {
    _data = prepareSerializePostChatMessageResult(_data as PostChatMessageResult);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePostChatMessageResult(_data: PostChatMessageResult): PostChatMessageResult {
  const data: Record<string, any> = { ..._data };
  return data as PostChatMessageResult;
}
export type DescribeVariableDto = {
  variableId: number;
  revisionId: number;
  projectId: number;
  userPrompt: string;
  postfix: string | null;
}
export function deserializeDescribeVariableDto(json: string): DescribeVariableDto {
  const data = JSON.parse(json) as DescribeVariableDto;
  initDescribeVariableDto(data);
  return data;
}
export function initDescribeVariableDto(_data: DescribeVariableDto) {
    return _data;
}
export function serializeDescribeVariableDto(_data: DescribeVariableDto | undefined) {
  if (_data) {
    _data = prepareSerializeDescribeVariableDto(_data as DescribeVariableDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeDescribeVariableDto(_data: DescribeVariableDto): DescribeVariableDto {
  const data: Record<string, any> = { ..._data };
  return data as DescribeVariableDto;
}
export type ProcessChatMessageDto = {
  chatMessage: ChatMessageDto;
  previousResponseId: string | null;
}
export function deserializeProcessChatMessageDto(json: string): ProcessChatMessageDto {
  const data = JSON.parse(json) as ProcessChatMessageDto;
  initProcessChatMessageDto(data);
  return data;
}
export function initProcessChatMessageDto(_data: ProcessChatMessageDto) {
  if (_data) {
    _data.chatMessage = _data["chatMessage"] && initChatMessageDto(_data["chatMessage"]);
  }
  return _data;
}
export function serializeProcessChatMessageDto(_data: ProcessChatMessageDto | undefined) {
  if (_data) {
    _data = prepareSerializeProcessChatMessageDto(_data as ProcessChatMessageDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeProcessChatMessageDto(_data: ProcessChatMessageDto): ProcessChatMessageDto {
  const data: Record<string, any> = { ..._data };
  data["chatMessage"] = _data.chatMessage && prepareSerializeChatMessageDto(_data.chatMessage);
  return data as ProcessChatMessageDto;
}
export type ChatMessageDto = {
  message: string;
  images: string[];
}
export function deserializeChatMessageDto(json: string): ChatMessageDto {
  const data = JSON.parse(json) as ChatMessageDto;
  initChatMessageDto(data);
  return data;
}
export function initChatMessageDto(_data: ChatMessageDto) {
  if (_data) {
    _data.images = _data["images"];
  }
  return _data;
}
export function serializeChatMessageDto(_data: ChatMessageDto | undefined) {
  if (_data) {
    _data = prepareSerializeChatMessageDto(_data as ChatMessageDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeChatMessageDto(_data: ChatMessageDto): ChatMessageDto {
  const data: Record<string, any> = { ..._data };
  return data as ChatMessageDto;
}
export enum ExternalEditingType {
    SharepointWordBrowser = "SharepointWordBrowser",
    SharepointWordApp = "SharepointWordApp",
}
export type DocumentDto = {
  id: number;
  name: string;
  status: Status;
  content: string;
  initialId: number | null;
  isReadOnly: boolean;
  /** True if document content is a Word document. */
  isOpenXml: boolean;
  versionUpdaterUser: DocumentVersionUpdaterUserDto | null;
  hasTemplateUpdate: boolean;
  /** True if current version of document is exported to SharePoint.
False if document is not exported or was changed after exporting. */
  isExported: boolean;
  /** Indicates if document should be reopened after update */
  isNeedToBeReopened: boolean;
  variables: RefDocumentVariableDto[];
}
export function deserializeDocumentDto(json: string): DocumentDto {
  const data = JSON.parse(json) as DocumentDto;
  initDocumentDto(data);
  return data;
}
export function initDocumentDto(_data: DocumentDto) {
  if (_data) {
    _data.status = _data["status"];
    _data.versionUpdaterUser = _data["versionUpdaterUser"] && initDocumentVersionUpdaterUserDto(_data["versionUpdaterUser"]);
    if (Array.isArray(_data["variables"])) {
      _data.variables = _data["variables"].map(item => 
        initRefDocumentVariableDto(item)
      );
    }
  }
  return _data;
}
export function serializeDocumentDto(_data: DocumentDto | undefined) {
  if (_data) {
    _data = prepareSerializeDocumentDto(_data as DocumentDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeDocumentDto(_data: DocumentDto): DocumentDto {
  const data: Record<string, any> = { ..._data };
  data["versionUpdaterUser"] = _data.versionUpdaterUser && prepareSerializeDocumentVersionUpdaterUserDto(_data.versionUpdaterUser);
  if (Array.isArray(_data.variables)) {
    data["variables"] = _data.variables.map(item => 
        prepareSerializeRefDocumentVariableDto(item)
    );
  }
  return data as DocumentDto;
}
export enum Status {
    Draft = "Draft",
    ReadyForReview = "ReadyForReview",
    CanBeSigned = "CanBeSigned",
    Signing = "Signing",
    Signed = "Signed",
    NotApplicable = "NotApplicable",
}
export type DocumentVersionUpdaterUserDto = {
  name: string;
  updatedAt: Date;
}
export function deserializeDocumentVersionUpdaterUserDto(json: string): DocumentVersionUpdaterUserDto {
  const data = JSON.parse(json) as DocumentVersionUpdaterUserDto;
  initDocumentVersionUpdaterUserDto(data);
  return data;
}
export function initDocumentVersionUpdaterUserDto(_data: DocumentVersionUpdaterUserDto) {
  if (_data) {
    _data.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
  }
  return _data;
}
export function serializeDocumentVersionUpdaterUserDto(_data: DocumentVersionUpdaterUserDto | undefined) {
  if (_data) {
    _data = prepareSerializeDocumentVersionUpdaterUserDto(_data as DocumentVersionUpdaterUserDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeDocumentVersionUpdaterUserDto(_data: DocumentVersionUpdaterUserDto): DocumentVersionUpdaterUserDto {
  const data: Record<string, any> = { ..._data };
  data["updatedAt"] = _data.updatedAt && _data.updatedAt.toISOString();
  return data as DocumentVersionUpdaterUserDto;
}
export type RefDocumentVariableDto = {
  id: number;
  systemVariableType: SystemVariableType | null;
}
export function deserializeRefDocumentVariableDto(json: string): RefDocumentVariableDto {
  const data = JSON.parse(json) as RefDocumentVariableDto;
  initRefDocumentVariableDto(data);
  return data;
}
export function initRefDocumentVariableDto(_data: RefDocumentVariableDto) {
  if (_data) {
    _data.systemVariableType = _data["systemVariableType"];
  }
  return _data;
}
export function serializeRefDocumentVariableDto(_data: RefDocumentVariableDto | undefined) {
  if (_data) {
    _data = prepareSerializeRefDocumentVariableDto(_data as RefDocumentVariableDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeRefDocumentVariableDto(_data: RefDocumentVariableDto): RefDocumentVariableDto {
  const data: Record<string, any> = { ..._data };
  return data as RefDocumentVariableDto;
}
export type RefDocumentEditingUserDto = {
  isLocked: boolean;
  id: number | null;
  editingType: DocumentEditingType | null;
  sessionIdentifier: string | null;
  userName: string | null;
  lockoutEnd: Date | null;
}
export function deserializeRefDocumentEditingUserDto(json: string): RefDocumentEditingUserDto {
  const data = JSON.parse(json) as RefDocumentEditingUserDto;
  initRefDocumentEditingUserDto(data);
  return data;
}
export function initRefDocumentEditingUserDto(_data: RefDocumentEditingUserDto) {
  if (_data) {
    _data.editingType = _data["editingType"];
    _data.lockoutEnd = _data["lockoutEnd"] ? new Date(_data["lockoutEnd"].toString()) : <any>null;
  }
  return _data;
}
export function serializeRefDocumentEditingUserDto(_data: RefDocumentEditingUserDto | undefined) {
  if (_data) {
    _data = prepareSerializeRefDocumentEditingUserDto(_data as RefDocumentEditingUserDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeRefDocumentEditingUserDto(_data: RefDocumentEditingUserDto): RefDocumentEditingUserDto {
  const data: Record<string, any> = { ..._data };
  data["lockoutEnd"] = _data.lockoutEnd && _data.lockoutEnd.toISOString();
  return data as RefDocumentEditingUserDto;
}
export enum DocumentEditingType {
    Magadan = "Magadan",
    Office365 = "Office365",
}
export type CreateDocumentDto = {
  name: string;
  revisionId: number;
  content: string;
  status: Status;
  isReadOnly: boolean;
  isImported: boolean;
  folderId: string | null;
}
export function deserializeCreateDocumentDto(json: string): CreateDocumentDto {
  const data = JSON.parse(json) as CreateDocumentDto;
  initCreateDocumentDto(data);
  return data;
}
export function initCreateDocumentDto(_data: CreateDocumentDto) {
  if (_data) {
    _data.status = _data["status"];
  }
  return _data;
}
export function serializeCreateDocumentDto(_data: CreateDocumentDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateDocumentDto(_data as CreateDocumentDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateDocumentDto(_data: CreateDocumentDto): CreateDocumentDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateDocumentDto;
}
export type CreateDocumentBasedOnTemplateDto = {
  templateId: number;
  revisionId: number;
  status: Status;
  folderId: string | null;
}
export function deserializeCreateDocumentBasedOnTemplateDto(json: string): CreateDocumentBasedOnTemplateDto {
  const data = JSON.parse(json) as CreateDocumentBasedOnTemplateDto;
  initCreateDocumentBasedOnTemplateDto(data);
  return data;
}
export function initCreateDocumentBasedOnTemplateDto(_data: CreateDocumentBasedOnTemplateDto) {
  if (_data) {
    _data.status = _data["status"];
  }
  return _data;
}
export function serializeCreateDocumentBasedOnTemplateDto(_data: CreateDocumentBasedOnTemplateDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateDocumentBasedOnTemplateDto(_data as CreateDocumentBasedOnTemplateDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateDocumentBasedOnTemplateDto(_data: CreateDocumentBasedOnTemplateDto): CreateDocumentBasedOnTemplateDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateDocumentBasedOnTemplateDto;
}
export type PatchDocumentDto = {
  name?: string;
  content?: string;
  status?: Status;
  versionEntry?: PatchDocumentVersionEntry;
  isExported?: boolean;
  isImported?: boolean;
}
export function deserializePatchDocumentDto(json: string): PatchDocumentDto {
  const data = JSON.parse(json) as PatchDocumentDto;
  initPatchDocumentDto(data);
  return data;
}
export function initPatchDocumentDto(_data: PatchDocumentDto) {
  if (_data) {
    _data.status = _data["status"];
    _data.versionEntry = _data["versionEntry"] && initPatchDocumentVersionEntry(_data["versionEntry"]);
  }
  return _data;
}
export function serializePatchDocumentDto(_data: PatchDocumentDto | undefined) {
  if (_data) {
    _data = prepareSerializePatchDocumentDto(_data as PatchDocumentDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatchDocumentDto(_data: PatchDocumentDto): PatchDocumentDto {
  const data: Record<string, any> = { ..._data };
  data["versionEntry"] = _data.versionEntry && prepareSerializePatchDocumentVersionEntry(_data.versionEntry);
  return data as PatchDocumentDto;
}
export type PatchDocumentVersionEntry = {
  version: string | null;
  autoIncrementVersion: boolean | null;
  isEmpty?: boolean;
}
export function deserializePatchDocumentVersionEntry(json: string): PatchDocumentVersionEntry {
  const data = JSON.parse(json) as PatchDocumentVersionEntry;
  initPatchDocumentVersionEntry(data);
  return data;
}
export function initPatchDocumentVersionEntry(_data: PatchDocumentVersionEntry) {
    return _data;
}
export function serializePatchDocumentVersionEntry(_data: PatchDocumentVersionEntry | undefined) {
  if (_data) {
    _data = prepareSerializePatchDocumentVersionEntry(_data as PatchDocumentVersionEntry);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatchDocumentVersionEntry(_data: PatchDocumentVersionEntry): PatchDocumentVersionEntry {
  const data: Record<string, any> = { ..._data };
  return data as PatchDocumentVersionEntry;
}
export type PatchDocumentEntry = {
  id: number;
  patchDto: PatchDocumentDto;
}
export function deserializePatchDocumentEntry(json: string): PatchDocumentEntry {
  const data = JSON.parse(json) as PatchDocumentEntry;
  initPatchDocumentEntry(data);
  return data;
}
export function initPatchDocumentEntry(_data: PatchDocumentEntry) {
  if (_data) {
    _data.patchDto = _data["patchDto"] && initPatchDocumentDto(_data["patchDto"]);
  }
  return _data;
}
export function serializePatchDocumentEntry(_data: PatchDocumentEntry | undefined) {
  if (_data) {
    _data = prepareSerializePatchDocumentEntry(_data as PatchDocumentEntry);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatchDocumentEntry(_data: PatchDocumentEntry): PatchDocumentEntry {
  const data: Record<string, any> = { ..._data };
  data["patchDto"] = _data.patchDto && prepareSerializePatchDocumentDto(_data.patchDto);
  return data as PatchDocumentEntry;
}
export type PagedResultOfDocumentListItemDto = {
  data: DocumentListItemDto[];
  totalCount: number;
}
export function deserializePagedResultOfDocumentListItemDto(json: string): PagedResultOfDocumentListItemDto {
  const data = JSON.parse(json) as PagedResultOfDocumentListItemDto;
  initPagedResultOfDocumentListItemDto(data);
  return data;
}
export function initPagedResultOfDocumentListItemDto(_data: PagedResultOfDocumentListItemDto) {
  if (_data) {
    if (Array.isArray(_data["data"])) {
      _data.data = _data["data"].map(item => 
        initDocumentListItemDto(item)
      );
    }
  }
  return _data;
}
export function serializePagedResultOfDocumentListItemDto(_data: PagedResultOfDocumentListItemDto | undefined) {
  if (_data) {
    _data = prepareSerializePagedResultOfDocumentListItemDto(_data as PagedResultOfDocumentListItemDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePagedResultOfDocumentListItemDto(_data: PagedResultOfDocumentListItemDto): PagedResultOfDocumentListItemDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.data)) {
    data["data"] = _data.data.map(item => 
        prepareSerializeDocumentListItemDto(item)
    );
  }
  return data as PagedResultOfDocumentListItemDto;
}
export type DocumentListItemDto = {
  id: number;
  name: string;
  status: Status;
  initialId: number | null;
  isReadOnly: boolean;
  /** True if document content is a Word document. */
  isOpenXml: boolean;
  version: string;
  isExported: boolean;
  versionUpdaterUser: DocumentVersionUpdaterUserDto | null;
  expiredVariables: ExpiredVariableDto[];
  deletionBlockReason: DocumentDeletionBlockReason;
  canBeDeleted: boolean;
  templateWithUpdate: TemplateWithUpdateDto | null;
  auditData: AuditDataDto | null;
  date: string;
}
export function deserializeDocumentListItemDto(json: string): DocumentListItemDto {
  const data = JSON.parse(json) as DocumentListItemDto;
  initDocumentListItemDto(data);
  return data;
}
export function initDocumentListItemDto(_data: DocumentListItemDto) {
  if (_data) {
    _data.status = _data["status"];
    _data.versionUpdaterUser = _data["versionUpdaterUser"] && initDocumentVersionUpdaterUserDto(_data["versionUpdaterUser"]);
    if (Array.isArray(_data["expiredVariables"])) {
      _data.expiredVariables = _data["expiredVariables"].map(item => 
        initExpiredVariableDto(item)
      );
    }
    _data.deletionBlockReason = _data["deletionBlockReason"];
    _data.templateWithUpdate = _data["templateWithUpdate"] && initTemplateWithUpdateDto(_data["templateWithUpdate"]);
    _data.auditData = _data["auditData"] && initAuditDataDto(_data["auditData"]);
  }
  return _data;
}
export function serializeDocumentListItemDto(_data: DocumentListItemDto | undefined) {
  if (_data) {
    _data = prepareSerializeDocumentListItemDto(_data as DocumentListItemDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeDocumentListItemDto(_data: DocumentListItemDto): DocumentListItemDto {
  const data: Record<string, any> = { ..._data };
  data["versionUpdaterUser"] = _data.versionUpdaterUser && prepareSerializeDocumentVersionUpdaterUserDto(_data.versionUpdaterUser);
  if (Array.isArray(_data.expiredVariables)) {
    data["expiredVariables"] = _data.expiredVariables.map(item => 
        prepareSerializeExpiredVariableDto(item)
    );
  }
  data["templateWithUpdate"] = _data.templateWithUpdate && prepareSerializeTemplateWithUpdateDto(_data.templateWithUpdate);
  data["auditData"] = _data.auditData && prepareSerializeAuditDataDto(_data.auditData);
  return data as DocumentListItemDto;
}
export type ExpiredVariableDto = {
  variableId: number;
  variableName: string;
  variableUpdateDate: Date;
}
export function deserializeExpiredVariableDto(json: string): ExpiredVariableDto {
  const data = JSON.parse(json) as ExpiredVariableDto;
  initExpiredVariableDto(data);
  return data;
}
export function initExpiredVariableDto(_data: ExpiredVariableDto) {
  if (_data) {
    _data.variableUpdateDate = _data["variableUpdateDate"] ? new Date(_data["variableUpdateDate"].toString()) : <any>null;
  }
  return _data;
}
export function serializeExpiredVariableDto(_data: ExpiredVariableDto | undefined) {
  if (_data) {
    _data = prepareSerializeExpiredVariableDto(_data as ExpiredVariableDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeExpiredVariableDto(_data: ExpiredVariableDto): ExpiredVariableDto {
  const data: Record<string, any> = { ..._data };
  data["variableUpdateDate"] = _data.variableUpdateDate && _data.variableUpdateDate.toISOString();
  return data as ExpiredVariableDto;
}
export type TemplateWithUpdateDto = {
  id: number;
  initialId: number | null;
  name: string;
  auditData: AuditDataDto | null;
}
export function deserializeTemplateWithUpdateDto(json: string): TemplateWithUpdateDto {
  const data = JSON.parse(json) as TemplateWithUpdateDto;
  initTemplateWithUpdateDto(data);
  return data;
}
export function initTemplateWithUpdateDto(_data: TemplateWithUpdateDto) {
  if (_data) {
    _data.auditData = _data["auditData"] && initAuditDataDto(_data["auditData"]);
  }
  return _data;
}
export function serializeTemplateWithUpdateDto(_data: TemplateWithUpdateDto | undefined) {
  if (_data) {
    _data = prepareSerializeTemplateWithUpdateDto(_data as TemplateWithUpdateDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeTemplateWithUpdateDto(_data: TemplateWithUpdateDto): TemplateWithUpdateDto {
  const data: Record<string, any> = { ..._data };
  data["auditData"] = _data.auditData && prepareSerializeAuditDataDto(_data.auditData);
  return data as TemplateWithUpdateDto;
}
export type GetPlainTextTableRequestBody = {
  variableValue: string;
  isLandscapeOrientation: boolean;
  fontSize: number;
  fontName: string;
}
export function deserializeGetPlainTextTableRequestBody(json: string): GetPlainTextTableRequestBody {
  const data = JSON.parse(json) as GetPlainTextTableRequestBody;
  initGetPlainTextTableRequestBody(data);
  return data;
}
export function initGetPlainTextTableRequestBody(_data: GetPlainTextTableRequestBody) {
    return _data;
}
export function serializeGetPlainTextTableRequestBody(_data: GetPlainTextTableRequestBody | undefined) {
  if (_data) {
    _data = prepareSerializeGetPlainTextTableRequestBody(_data as GetPlainTextTableRequestBody);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeGetPlainTextTableRequestBody(_data: GetPlainTextTableRequestBody): GetPlainTextTableRequestBody {
  const data: Record<string, any> = { ..._data };
  return data as GetPlainTextTableRequestBody;
}
export type ApplyVariablesToDocumentDto = {
  variableIds: number[];
  revisionId: number;
  documentContent: string;
}
export function deserializeApplyVariablesToDocumentDto(json: string): ApplyVariablesToDocumentDto {
  const data = JSON.parse(json) as ApplyVariablesToDocumentDto;
  initApplyVariablesToDocumentDto(data);
  return data;
}
export function initApplyVariablesToDocumentDto(_data: ApplyVariablesToDocumentDto) {
  if (_data) {
    _data.variableIds = _data["variableIds"];
  }
  return _data;
}
export function serializeApplyVariablesToDocumentDto(_data: ApplyVariablesToDocumentDto | undefined) {
  if (_data) {
    _data = prepareSerializeApplyVariablesToDocumentDto(_data as ApplyVariablesToDocumentDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeApplyVariablesToDocumentDto(_data: ApplyVariablesToDocumentDto): ApplyVariablesToDocumentDto {
  const data: Record<string, any> = { ..._data };
  return data as ApplyVariablesToDocumentDto;
}
export type AvailableRolesDto = {
  documentId: number;
  roles: ProjectRoleDto[];
}
export function deserializeAvailableRolesDto(json: string): AvailableRolesDto {
  const data = JSON.parse(json) as AvailableRolesDto;
  initAvailableRolesDto(data);
  return data;
}
export function initAvailableRolesDto(_data: AvailableRolesDto) {
  if (_data) {
    if (Array.isArray(_data["roles"])) {
      _data.roles = _data["roles"].map(item => 
        initProjectRoleDto(item)
      );
    }
  }
  return _data;
}
export function serializeAvailableRolesDto(_data: AvailableRolesDto | undefined) {
  if (_data) {
    _data = prepareSerializeAvailableRolesDto(_data as AvailableRolesDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeAvailableRolesDto(_data: AvailableRolesDto): AvailableRolesDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.roles)) {
    data["roles"] = _data.roles.map(item => 
        prepareSerializeProjectRoleDto(item)
    );
  }
  return data as AvailableRolesDto;
}
export type DocumentSigningStatusDto = {
  documentId: number;
  isSigning: boolean;
  roles: RoleSigningStatusDto[];
}
export function deserializeDocumentSigningStatusDto(json: string): DocumentSigningStatusDto {
  const data = JSON.parse(json) as DocumentSigningStatusDto;
  initDocumentSigningStatusDto(data);
  return data;
}
export function initDocumentSigningStatusDto(_data: DocumentSigningStatusDto) {
  if (_data) {
    if (Array.isArray(_data["roles"])) {
      _data.roles = _data["roles"].map(item => 
        initRoleSigningStatusDto(item)
      );
    }
  }
  return _data;
}
export function serializeDocumentSigningStatusDto(_data: DocumentSigningStatusDto | undefined) {
  if (_data) {
    _data = prepareSerializeDocumentSigningStatusDto(_data as DocumentSigningStatusDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeDocumentSigningStatusDto(_data: DocumentSigningStatusDto): DocumentSigningStatusDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.roles)) {
    data["roles"] = _data.roles.map(item => 
        prepareSerializeRoleSigningStatusDto(item)
    );
  }
  return data as DocumentSigningStatusDto;
}
export type RoleSigningStatusDto = {
  role: ProjectRoleDto;
  status: RoleSigningStatus;
  /** Required to inform user, that role can not be deleted. */
  isDeletable: boolean;
}
export function deserializeRoleSigningStatusDto(json: string): RoleSigningStatusDto {
  const data = JSON.parse(json) as RoleSigningStatusDto;
  initRoleSigningStatusDto(data);
  return data;
}
export function initRoleSigningStatusDto(_data: RoleSigningStatusDto) {
  if (_data) {
    _data.role = _data["role"] && initProjectRoleDto(_data["role"]);
    _data.status = _data["status"];
  }
  return _data;
}
export function serializeRoleSigningStatusDto(_data: RoleSigningStatusDto | undefined) {
  if (_data) {
    _data = prepareSerializeRoleSigningStatusDto(_data as RoleSigningStatusDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeRoleSigningStatusDto(_data: RoleSigningStatusDto): RoleSigningStatusDto {
  const data: Record<string, any> = { ..._data };
  data["role"] = _data.role && prepareSerializeProjectRoleDto(_data.role);
  return data as RoleSigningStatusDto;
}
export enum RoleSigningStatus {
    NotStarted = "NotStarted",
    WaitingForItsTurn = "WaitingForItsTurn",
    WaitingForSignature = "WaitingForSignature",
    SignedByAnotherRole = "SignedByAnotherRole",
    Signed = "Signed",
    InvalidSignature = "InvalidSignature",
    InvalidSigner = "InvalidSigner",
}
export type SignerToResendNotificationDto = {
  documentId: number;
  roleName: string;
  signer: SignerDto;
}
export function deserializeSignerToResendNotificationDto(json: string): SignerToResendNotificationDto {
  const data = JSON.parse(json) as SignerToResendNotificationDto;
  initSignerToResendNotificationDto(data);
  return data;
}
export function initSignerToResendNotificationDto(_data: SignerToResendNotificationDto) {
  if (_data) {
    _data.signer = _data["signer"] && initSignerDto(_data["signer"]);
  }
  return _data;
}
export function serializeSignerToResendNotificationDto(_data: SignerToResendNotificationDto | undefined) {
  if (_data) {
    _data = prepareSerializeSignerToResendNotificationDto(_data as SignerToResendNotificationDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeSignerToResendNotificationDto(_data: SignerToResendNotificationDto): SignerToResendNotificationDto {
  const data: Record<string, any> = { ..._data };
  data["signer"] = _data.signer && prepareSerializeSignerDto(_data.signer);
  return data as SignerToResendNotificationDto;
}
export enum DocumentType {
    Document = "Document",
    Template = "Template",
}
export enum DocumentExportFormat {
    OpenXml = "OpenXml",
    Rtf = "Rtf",
    Pdf = "Pdf",
    Dotx = "Dotx",
}
export type DocumentPreparationInfo = {
  revisionId: number;
  documentId: number | null;
  documentContent: string;
}
export function deserializeDocumentPreparationInfo(json: string): DocumentPreparationInfo {
  const data = JSON.parse(json) as DocumentPreparationInfo;
  initDocumentPreparationInfo(data);
  return data;
}
export function initDocumentPreparationInfo(_data: DocumentPreparationInfo) {
    return _data;
}
export function serializeDocumentPreparationInfo(_data: DocumentPreparationInfo | undefined) {
  if (_data) {
    _data = prepareSerializeDocumentPreparationInfo(_data as DocumentPreparationInfo);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeDocumentPreparationInfo(_data: DocumentPreparationInfo): DocumentPreparationInfo {
  const data: Record<string, any> = { ..._data };
  return data as DocumentPreparationInfo;
}
export type TemplatePreparationInfo = {
  documentContent: string;
}
export function deserializeTemplatePreparationInfo(json: string): TemplatePreparationInfo {
  const data = JSON.parse(json) as TemplatePreparationInfo;
  initTemplatePreparationInfo(data);
  return data;
}
export function initTemplatePreparationInfo(_data: TemplatePreparationInfo) {
    return _data;
}
export function serializeTemplatePreparationInfo(_data: TemplatePreparationInfo | undefined) {
  if (_data) {
    _data = prepareSerializeTemplatePreparationInfo(_data as TemplatePreparationInfo);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeTemplatePreparationInfo(_data: TemplatePreparationInfo): TemplatePreparationInfo {
  const data: Record<string, any> = { ..._data };
  return data as TemplatePreparationInfo;
}
export type ExportDocumentTreeDto = {
  selections: SelectionEntryDto[];
  revisionId: number;
}
export function deserializeExportDocumentTreeDto(json: string): ExportDocumentTreeDto {
  const data = JSON.parse(json) as ExportDocumentTreeDto;
  initExportDocumentTreeDto(data);
  return data;
}
export function initExportDocumentTreeDto(_data: ExportDocumentTreeDto) {
  if (_data) {
    if (Array.isArray(_data["selections"])) {
      _data.selections = _data["selections"].map(item => 
        initSelectionEntryDto(item)
      );
    }
  }
  return _data;
}
export function serializeExportDocumentTreeDto(_data: ExportDocumentTreeDto | undefined) {
  if (_data) {
    _data = prepareSerializeExportDocumentTreeDto(_data as ExportDocumentTreeDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeExportDocumentTreeDto(_data: ExportDocumentTreeDto): ExportDocumentTreeDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.selections)) {
    data["selections"] = _data.selections.map(item => 
        prepareSerializeSelectionEntryDto(item)
    );
  }
  return data as ExportDocumentTreeDto;
}
export type CommentDto = {
  id: number;
  text: string;
  auditData: AuditDataDto;
}
export function deserializeCommentDto(json: string): CommentDto {
  const data = JSON.parse(json) as CommentDto;
  initCommentDto(data);
  return data;
}
export function initCommentDto(_data: CommentDto) {
  if (_data) {
    _data.auditData = _data["auditData"] && initAuditDataDto(_data["auditData"]);
  }
  return _data;
}
export function serializeCommentDto(_data: CommentDto | undefined) {
  if (_data) {
    _data = prepareSerializeCommentDto(_data as CommentDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCommentDto(_data: CommentDto): CommentDto {
  const data: Record<string, any> = { ..._data };
  data["auditData"] = _data.auditData && prepareSerializeAuditDataDto(_data.auditData);
  return data as CommentDto;
}
export type CreateCommentDto = {
  text: string;
  documentId: number;
}
export function deserializeCreateCommentDto(json: string): CreateCommentDto {
  const data = JSON.parse(json) as CreateCommentDto;
  initCreateCommentDto(data);
  return data;
}
export function initCreateCommentDto(_data: CreateCommentDto) {
    return _data;
}
export function serializeCreateCommentDto(_data: CreateCommentDto | undefined) {
  if (_data) {
    _data = prepareSerializeCreateCommentDto(_data as CreateCommentDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCreateCommentDto(_data: CreateCommentDto): CreateCommentDto {
  const data: Record<string, any> = { ..._data };
  return data as CreateCommentDto;
}
export type PatchCommentDto = {
  text?: string;
}
export function deserializePatchCommentDto(json: string): PatchCommentDto {
  const data = JSON.parse(json) as PatchCommentDto;
  initPatchCommentDto(data);
  return data;
}
export function initPatchCommentDto(_data: PatchCommentDto) {
    return _data;
}
export function serializePatchCommentDto(_data: PatchCommentDto | undefined) {
  if (_data) {
    _data = prepareSerializePatchCommentDto(_data as PatchCommentDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePatchCommentDto(_data: PatchCommentDto): PatchCommentDto {
  const data: Record<string, any> = { ..._data };
  return data as PatchCommentDto;
}
export type PagedResultOfCommentListItemDto = {
  data: CommentListItemDto[];
  totalCount: number;
}
export function deserializePagedResultOfCommentListItemDto(json: string): PagedResultOfCommentListItemDto {
  const data = JSON.parse(json) as PagedResultOfCommentListItemDto;
  initPagedResultOfCommentListItemDto(data);
  return data;
}
export function initPagedResultOfCommentListItemDto(_data: PagedResultOfCommentListItemDto) {
  if (_data) {
    if (Array.isArray(_data["data"])) {
      _data.data = _data["data"].map(item => 
        initCommentListItemDto(item)
      );
    }
  }
  return _data;
}
export function serializePagedResultOfCommentListItemDto(_data: PagedResultOfCommentListItemDto | undefined) {
  if (_data) {
    _data = prepareSerializePagedResultOfCommentListItemDto(_data as PagedResultOfCommentListItemDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializePagedResultOfCommentListItemDto(_data: PagedResultOfCommentListItemDto): PagedResultOfCommentListItemDto {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.data)) {
    data["data"] = _data.data.map(item => 
        prepareSerializeCommentListItemDto(item)
    );
  }
  return data as PagedResultOfCommentListItemDto;
}
export type CommentListItemDto = {
  id: number;
  text: string;
  auditData: AuditDataDto;
}
export function deserializeCommentListItemDto(json: string): CommentListItemDto {
  const data = JSON.parse(json) as CommentListItemDto;
  initCommentListItemDto(data);
  return data;
}
export function initCommentListItemDto(_data: CommentListItemDto) {
  if (_data) {
    _data.auditData = _data["auditData"] && initAuditDataDto(_data["auditData"]);
  }
  return _data;
}
export function serializeCommentListItemDto(_data: CommentListItemDto | undefined) {
  if (_data) {
    _data = prepareSerializeCommentListItemDto(_data as CommentListItemDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeCommentListItemDto(_data: CommentListItemDto): CommentListItemDto {
  const data: Record<string, any> = { ..._data };
  data["auditData"] = _data.auditData && prepareSerializeAuditDataDto(_data.auditData);
  return data as CommentListItemDto;
}
export type TestPatchDto = {
  value?: string;
}
export function deserializeTestPatchDto(json: string): TestPatchDto {
  const data = JSON.parse(json) as TestPatchDto;
  initTestPatchDto(data);
  return data;
}
export function initTestPatchDto(_data: TestPatchDto) {
    return _data;
}
export function serializeTestPatchDto(_data: TestPatchDto | undefined) {
  if (_data) {
    _data = prepareSerializeTestPatchDto(_data as TestPatchDto);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeTestPatchDto(_data: TestPatchDto): TestPatchDto {
  const data: Record<string, any> = { ..._data };
  return data as TestPatchDto;
}
export type TableData = {
  columns: string[];
  fields: { [key: string]: any; }[];
  /** Optional. Contains merged cells information.
Format: {rowIndex: {startCellIndex: endCellIndex}} */
  merged_cells?: { [key: string]: { [key: string]: number; }; } | null;
  /** Optional. Contains predefined table cells properties. */
  cells_properties?: TableDataCellProperties[] | null;
}
export function deserializeTableData(json: string): TableData {
  const data = JSON.parse(json) as TableData;
  initTableData(data);
  return data;
}
export function initTableData(_data: TableData) {
  if (_data) {
    _data.columns = _data["columns"];
    _data.fields = _data["fields"];
    if (Array.isArray(_data["cells_properties"])) {
      _data.cells_properties = _data["cells_properties"].map(item => 
        initTableDataCellProperties(item)
      );
    }
  }
  return _data;
}
export function serializeTableData(_data: TableData | undefined) {
  if (_data) {
    _data = prepareSerializeTableData(_data as TableData);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeTableData(_data: TableData): TableData {
  const data: Record<string, any> = { ..._data };
  if (Array.isArray(_data.cells_properties)) {
    data["cells_properties"] = _data.cells_properties.map(item => 
        prepareSerializeTableDataCellProperties(item)
    );
  }
  return data as TableData;
}
export type TableDataCellProperties = {
  position: TableCellPosition;
  style: TableDataCellStyle;
}
export function deserializeTableDataCellProperties(json: string): TableDataCellProperties {
  const data = JSON.parse(json) as TableDataCellProperties;
  initTableDataCellProperties(data);
  return data;
}
export function initTableDataCellProperties(_data: TableDataCellProperties) {
  if (_data) {
    _data.position = _data["position"] && initTableCellPosition(_data["position"]);
    _data.style = _data["style"] && initTableDataCellStyle(_data["style"]);
  }
  return _data;
}
export function serializeTableDataCellProperties(_data: TableDataCellProperties | undefined) {
  if (_data) {
    _data = prepareSerializeTableDataCellProperties(_data as TableDataCellProperties);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeTableDataCellProperties(_data: TableDataCellProperties): TableDataCellProperties {
  const data: Record<string, any> = { ..._data };
  data["position"] = _data.position && prepareSerializeTableCellPosition(_data.position);
  data["style"] = _data.style && prepareSerializeTableDataCellStyle(_data.style);
  return data as TableDataCellProperties;
}
/** Determines cell position in table */
export type TableCellPosition = {
  row: number;
  cell: number;
}
export function deserializeTableCellPosition(json: string): TableCellPosition {
  const data = JSON.parse(json) as TableCellPosition;
  initTableCellPosition(data);
  return data;
}
export function initTableCellPosition(_data: TableCellPosition) {
    return _data;
}
export function serializeTableCellPosition(_data: TableCellPosition | undefined) {
  if (_data) {
    _data = prepareSerializeTableCellPosition(_data as TableCellPosition);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeTableCellPosition(_data: TableCellPosition): TableCellPosition {
  const data: Record<string, any> = { ..._data };
  return data as TableCellPosition;
}
/** Properties that will be applied to the table after insertion to the document. To apply them well, JSON properties names must be same as TableCell properties names. https://docs.devexpress.com/AspNetCore/js-DevExpress.RichEdit.TableCell */
export type TableDataCellStyle = {
  bold: boolean | null;
  backgroundColor: string | null;
}
export function deserializeTableDataCellStyle(json: string): TableDataCellStyle {
  const data = JSON.parse(json) as TableDataCellStyle;
  initTableDataCellStyle(data);
  return data;
}
export function initTableDataCellStyle(_data: TableDataCellStyle) {
    return _data;
}
export function serializeTableDataCellStyle(_data: TableDataCellStyle | undefined) {
  if (_data) {
    _data = prepareSerializeTableDataCellStyle(_data as TableDataCellStyle);
  }
  return JSON.stringify(_data);
}
export function prepareSerializeTableDataCellStyle(_data: TableDataCellStyle): TableDataCellStyle {
  const data: Record<string, any> = { ..._data };
  return data as TableDataCellStyle;
}
import type { AxiosError } from 'axios'
export interface FileParameter {
    data: any;
    fileName: string;
}
export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}
export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;
    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    protected isApiException = true;
    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}
export function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
export function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}
//-----/Types.File-----